// PLANTS MORE VEGETABLES
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const moreVegetablesData: PlantData[] = [
  {
    id: 'eggplant-black-beauty',
    name: 'Eggplant - Black Beauty',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper'],
    enemies: ['fennel'],
    description: 'Classic dark purple eggplant. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2 feet',
    family: 'Solanaceae',
    varieties: ['Black Beauty', 'Ichiban'],
    uses: ['cooking', 'grilling', 'parmesan']
  },
  {
    id: 'okra-clemson-spineless',
    name: 'Okra - Clemson Spineless',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['pepper', 'eggplant'],
    enemies: [],
    description: 'Ribbed green pods, spineless. Thrives in hot weather.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Malvaceae',
    varieties: ['Clemson Spineless', 'Emerald'],
    uses: ['frying', 'gumbo', 'pickling']
  },
  {
    id: 'sweet-corn-sugar-enhanced',
    name: 'Sweet Corn - Sugar Enhanced',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber'],
    enemies: ['tomato'],
    description: 'Sweeter than standard corn, stays sweet longer after picking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Honey Select', 'Ambrosia'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'asparagus-mary-washington',
    name: 'Asparagus - Mary Washington',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6.5,
    phMax: 7.5,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Perennial vegetable, harvest in year 3. Female plants produce berries.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Mary Washington', 'Jersey Giant'],
    uses: ['cooking', 'grilling', 'fresh']
  },
  {
    id: 'brussels-sprout-long-island',
    name: 'Brussels Sprout - Long Island',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tall stalks with mini cabbages. Improved flavor after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Long Island Improved', 'Diablo'],
    uses: ['roasting', 'cooking', 'fresh']
  },
  {
    id: 'cauliflower-snowball',
    name: 'Cauliflower - Snowball',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'White heads, blanch by tying leaves over curd. Cool weather crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowball Y', 'Cheddar'],
    uses: ['cooking', 'roasting', 'fresh']
  },
  {
    id: 'cabbage-green',
    name: 'Cabbage - Green',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill'],
    enemies: ['strawberry'],
    description: 'Round green heads, excellent for slaw and cooking. Heavy feeder.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Acre', 'Copenhagen Market'],
    uses: ['slaw', 'cooking', 'fermenting']
  },
  {
    id: 'turnip-purple-top',
    name: 'Turnip - Purple Top',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'White roots with purple shoulders. Fast growing, edible greens.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Top White Globe', 'Hakurei'],
    uses: ['cooking', 'greens', 'roots']
  },
  {
    id: 'swiss-chard-bright-lights',
    name: 'Swiss Chard - Bright Lights',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Colorful stems in yellow, pink, red. Heat and cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Bright Lights', 'Fordhook Giant'],
    uses: ['greens', 'cooking', 'salads']
  },
  {
    id: 'collards-georgia',
    name: 'Collards - Georgia Southern',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'Large blue-green leaves, very cold hardy. Southern staple.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2 feet',
    family: 'Brassicaceae',
    varieties: ['Georgia Southern', 'Vates'],
    uses: ['cooking', 'greens', 'soup']
  },
  {
    id: 'arugula-wild',
    name: 'Arugula - Wild',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'Peppery leaves for salads. Fast growing, bolts in heat.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Wild', 'Astro'],
    uses: ['salads', 'pesto', 'garnish']
  },
  {
    id: 'bok-choy-joi-choi',
    name: 'Bok Choy - Joi Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Compact Chinese cabbage with white stems. Quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Joi Choi', 'Mei Qing'],
    uses: ['stir fry', 'soup', 'salads']
  }
,
  {
    id: 'bean-blue-lake-274',
    name: 'Bean - Blue Lake 274',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Blue Lake 274'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-contender',
    name: 'Bean - Contender',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Contender'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-provider',
    name: 'Bean - Provider',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Provider'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-topcrop',
    name: 'Bean - Topcrop',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 52,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Topcrop'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-tendercrop',
    name: 'Bean - Tendercrop',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Tendercrop'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-jade',
    name: 'Bean - Jade',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Jade'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-maxibel',
    name: 'Bean - Maxibel',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Maxibel'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-jade-ii',
    name: 'Bean - Jade II',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Jade II'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-bronco',
    name: 'Bean - Bronco',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Bronco'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-derby',
    name: 'Bean - Derby',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Derby'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-espada',
    name: 'Bean - Espada',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Espada'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-fortex',
    name: 'Bean - Fortex',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Fortex'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-gina',
    name: 'Bean - Gina',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Gina'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-hialeah',
    name: 'Bean - Hialeah',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Hialeah'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-labrador',
    name: 'Bean - Labrador',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Labrador'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-nickel',
    name: 'Bean - Nickel',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Nickel'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-plaza',
    name: 'Bean - Plaza',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Plaza'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-roma-ii',
    name: 'Bean - Roma II',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Roma II'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-seychelles',
    name: 'Bean - Seychelles',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Seychelles'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-slenderette',
    name: 'Bean - Slenderette',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Slenderette'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-tavera',
    name: 'Bean - Tavera',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Tavera'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-valentino',
    name: 'Bean - Valentino',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Valentino'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-capitano',
    name: 'Bean - Capitano',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Capitano'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-golden-wax',
    name: 'Bean - Golden Wax',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 52,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Golden Wax'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-improved-golden-wax',
    name: 'Bean - Improved Golden Wax',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Improved Golden Wax'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-pencil-pod-black-wax',
    name: 'Bean - Pencil Pod Black Wax',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 52,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pencil Pod Black Wax'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-roc-d-or',
    name: 'Bean - Roc d Or',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Roc d Or'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-top-notch',
    name: 'Bean - Top Notch',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Top Notch'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-wax',
    name: 'Bean - Wax',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Wax'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-carson',
    name: 'Bean - Carson',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Carson'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-gold-mine',
    name: 'Bean - Gold Mine',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Gold Mine'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-gold-rush',
    name: 'Bean - Gold Rush',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Gold Rush'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-kinghorn-wax',
    name: 'Bean - Kinghorn Wax',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Kinghorn Wax'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-monte-gusto',
    name: 'Bean - Monte Gusto',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Monte Gusto'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-rocquencourt',
    name: 'Bean - Rocquencourt',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Rocquencourt'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-borsalino',
    name: 'Bean - Borsalino',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Borsalino'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-bush-romano',
    name: 'Bean - Bush Romano',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Bush Romano'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-romano-bush',
    name: 'Bean - Romano Bush',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Romano Bush'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-romano-gold',
    name: 'Bean - Romano Gold',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Romano Gold'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-helda',
    name: 'Bean - Helda',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Helda'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-northeaster',
    name: 'Bean - Northeaster',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Northeaster'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-portofino',
    name: 'Bean - Portofino',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Portofino'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-french-mascotte',
    name: 'Bean - French Mascotte',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French Mascotte'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-ferrari',
    name: 'Bean - Ferrari',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Ferrari'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-mascotte',
    name: 'Bean - Mascotte',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mascotte'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-napoli',
    name: 'Bean - Napoli',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Napoli'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-saxa',
    name: 'Bean - Saxa',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Saxa'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-tendergreen',
    name: 'Bean - Tendergreen',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Tendergreen'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-bountiful',
    name: 'Bean - Bountiful',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Bountiful'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-burpees-stringless',
    name: 'Bean - Burpees Stringless',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Burpees Stringless'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-commodore',
    name: 'Bean - Commodore',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Commodore'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-eureka',
    name: 'Bean - Eureka',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Eureka'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-gourmet-delight',
    name: 'Bean - Gourmet Delight',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Gourmet Delight'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-harvester',
    name: 'Bean - Harvester',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Harvester'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-heavyweight-ii',
    name: 'Bean - Heavyweight II',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heavyweight II'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-landmark',
    name: 'Bean - Landmark',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Landmark'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-legend',
    name: 'Bean - Legend',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Legend'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-lindy',
    name: 'Bean - Lindy',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Lindy'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-maverick',
    name: 'Bean - Maverick',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Maverick'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-prevail',
    name: 'Bean - Prevail',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Prevail'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-strike',
    name: 'Bean - Strike',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Strike'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-triton',
    name: 'Bean - Triton',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Triton'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-venture',
    name: 'Bean - Venture',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Venture'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-victory',
    name: 'Bean - Victory',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Victory'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-dragon-tongue',
    name: 'Bean - Dragon Tongue',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Dragon Tongue'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-jacob-cattle',
    name: 'Bean - Jacob Cattle',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Jacob Cattle'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-vermont-cranberry',
    name: 'Bean - Vermont Cranberry',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vermont Cranberry'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-appaloosa',
    name: 'Bean - Appaloosa',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Appaloosa'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-good-mother-stallard',
    name: 'Bean - Good Mother Stallard',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled bush bean. Compact bush variety, no staking needed. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Good Mother Stallard'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-painted-pony',
    name: 'Bean - Painted Pony',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Painted Pony'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-rattlesnake',
    name: 'Bean - Rattlesnake',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Rattlesnake'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-tiger-eye',
    name: 'Bean - Tiger Eye',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Tiger Eye'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-black-turtle',
    name: 'Bean - Black Turtle',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'black bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black Turtle'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-black-valentine',
    name: 'Bean - Black Valentine',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'black bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black Valentine'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-midnight-black-turtle',
    name: 'Bean - Midnight Black Turtle',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'black bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Midnight Black Turtle'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-cherokee-trail-of-tears',
    name: 'Bean - Cherokee Trail of Tears',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'black bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Cherokee Trail of Tears'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-calypso',
    name: 'Bean - Calypso',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'black-white bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Calypso'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-orca',
    name: 'Bean - Orca',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'black-white bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Orca'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-yin-yang',
    name: 'Bean - Yin Yang',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'black-white bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Yin Yang'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-red-swan',
    name: 'Bean - Red Swan',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'red bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Swan'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-red-noodle',
    name: 'Bean - Red Noodle',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'red bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Noodle'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-red-chinese',
    name: 'Bean - Red Chinese',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'red bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Chinese'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-purple-queen',
    name: 'Bean - Purple Queen',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'purple bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Purple Queen'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-royal-burgundy',
    name: 'Bean - Royal Burgundy',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'purple bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Royal Burgundy'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-amethyst',
    name: 'Bean - Amethyst',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'purple bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Amethyst'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-velour',
    name: 'Bean - Velour',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'purple bush bean. Compact bush variety, no staking needed. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Velour'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-kentucky-wonder',
    name: 'Bean - Kentucky Wonder',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Kentucky Wonder'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-kentucky-blue',
    name: 'Bean - Kentucky Blue',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Kentucky Blue'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-fortex',
    name: 'Bean - Fortex',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Fortex'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-mccaslan',
    name: 'Bean - McCaslan',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['McCaslan'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-northeaster',
    name: 'Bean - Northeaster',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Northeaster'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-rattlesnake',
    name: 'Bean - Rattlesnake',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'speckled pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Rattlesnake'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-scarlet-runner',
    name: 'Bean - Scarlet Runner',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'red pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Scarlet Runner'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-trail-of-tears',
    name: 'Bean - Trail of Tears',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'black pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Trail of Tears'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-romano-pole',
    name: 'Bean - Romano Pole',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Romano Pole'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-musica',
    name: 'Bean - Musica',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Musica'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-helda',
    name: 'Bean - Helda',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Helda'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-marvel-of-venice',
    name: 'Bean - Marvel of Venice',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Marvel of Venice'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-gold-marie',
    name: 'Bean - Gold Marie',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'yellow pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Gold Marie'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-carminat',
    name: 'Bean - Carminat',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'purple pole bean. Vining habit, needs trellis support. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Carminat'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-blauhilde',
    name: 'Bean - Blauhilde',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'purple pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Blauhilde'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-purple-peacock',
    name: 'Bean - Purple Peacock',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'purple pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Purple Peacock'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean--yard-long',
    name: 'Bean -  yard Long',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: [' yard Long'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-red-noodle',
    name: 'Bean - Red Noodle',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'red pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Noodle'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-chinese-red-noodle',
    name: 'Bean - Chinese Red Noodle',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'red pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese Red Noodle'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  },
  {
    id: 'bean-asparagus-bean',
    name: 'Bean - Asparagus Bean',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish', 'carrot'],
    enemies: ['onion', 'garlic', 'fennel'],
    description: 'green pole bean. Vining habit, needs trellis support. Main season variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Asparagus Bean'],
    uses: ['fresh', 'cooking', 'canning', 'freezing']
  }
,
  {
    id: 'carrot-nantes',
    name: 'Carrot - Nantes',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange cylindrical carrot. Sweet, uniform roots, excellent for fresh eating. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Nantes'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-scarlet-nantes',
    name: 'Carrot - Scarlet Nantes',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange cylindrical carrot. Sweet, uniform roots, excellent for fresh eating. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Scarlet Nantes'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-nelson',
    name: 'Carrot - Nelson',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Nelson'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-napoli',
    name: 'Carrot - Napoli',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Napoli'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-napa',
    name: 'Carrot - Napa',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Napa'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-nantes-half-long',
    name: 'Carrot - Nantes Half Long',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange cylindrical carrot. Sweet, uniform roots, excellent for fresh eating. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Nantes Half Long'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-nantes-coreless',
    name: 'Carrot - Nantes Coreless',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange cylindrical carrot. Sweet, uniform roots, excellent for fresh eating. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Nantes Coreless'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-nantejsa',
    name: 'Carrot - Nantejsa',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Nantejsa'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-napoli-f1',
    name: 'Carrot - Napoli F1',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Napoli F1'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-nairobi',
    name: 'Carrot - Nairobi',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Nairobi'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-danvers-126',
    name: 'Carrot - Danvers 126',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange tapered carrot. Classic shape, good for heavy soils. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Danvers 126'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-danvers-half-long',
    name: 'Carrot - Danvers Half Long',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange tapered carrot. Classic shape, good for heavy soils. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Danvers Half Long'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-danvers-126-half-long',
    name: 'Carrot - Danvers 126 Half Long',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange tapered carrot. Classic shape, good for heavy soils. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Danvers 126 Half Long'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-danvers-half-long-scarlet',
    name: 'Carrot - Danvers Half Long Scarlet',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange tapered carrot. Classic shape, good for heavy soils. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Danvers Half Long Scarlet'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-chantenay-red-cored',
    name: 'Carrot - Chantenay Red Cored',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange blocky carrot. Short, broad roots, good for clay soil. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Chantenay Red Cored'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-chantenay',
    name: 'Carrot - Chantenay',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange blocky carrot. Short, broad roots, good for clay soil. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Chantenay'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-royal-chantenay',
    name: 'Carrot - Royal Chantenay',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange blocky carrot. Short, broad roots, good for clay soil. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Royal Chantenay'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-red-cored-chantenay',
    name: 'Carrot - Red Cored Chantenay',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange blocky carrot. Short, broad roots, good for clay soil. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Red Cored Chantenay'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-chantenay-de-juane',
    name: 'Carrot - Chantenay de Juane',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange blocky carrot. Short, broad roots, good for clay soil. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Chantenay de Juane'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-chantenay-de-rouge',
    name: 'Carrot - Chantenay de Rouge',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange blocky carrot. Short, broad roots, good for clay soil. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Chantenay de Rouge'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-imperator-58',
    name: 'Carrot - Imperator 58',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange long tapered carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Imperator 58'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-imperator',
    name: 'Carrot - Imperator',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange long tapered carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Imperator'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-autumn-king',
    name: 'Carrot - Autumn King',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Autumn King'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-autumn-king-10',
    name: 'Carrot - Autumn King 10',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Autumn King 10'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-berlicum-2',
    name: 'Carrot - Berlicum 2',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Berlicum 2'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-berlicum',
    name: 'Carrot - Berlicum',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Berlicum'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-bolero',
    name: 'Carrot - Bolero',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Bolero'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-bolero-f1',
    name: 'Carrot - Bolero F1',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Bolero F1'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-ingot',
    name: 'Carrot - Ingot',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Ingot'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-naval',
    name: 'Carrot - Naval',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Naval'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-romance',
    name: 'Carrot - Romance',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Romance'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-sugarsnax-54',
    name: 'Carrot - Sugarsnax 54',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 68,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Sugarsnax 54'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-sugarsnax',
    name: 'Carrot - Sugarsnax',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 68,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Sugarsnax'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-sugarsnax-54-f1',
    name: 'Carrot - Sugarsnax 54 F1',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 68,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Sugarsnax 54 F1'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-sweetness',
    name: 'Carrot - Sweetness',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Sweetness'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-sweet-treat',
    name: 'Carrot - Sweet Treat',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Sweet Treat'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-sugar-snax',
    name: 'Carrot - Sugar Snax',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Sugar Snax'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-mokum',
    name: 'Carrot - Mokum',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Mokum'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-mokum-f1',
    name: 'Carrot - Mokum F1',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Mokum F1'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-yaya',
    name: 'Carrot - Yaya',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Yaya'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-yaya-f1',
    name: 'Carrot - YaYa F1',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['YaYa F1'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-napoli-f1',
    name: 'Carrot - Napoli F1',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Napoli F1'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-white-satin',
    name: 'Carrot - White Satin',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'white standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['White Satin'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-lunar-white',
    name: 'Carrot - Lunar White',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'white standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Lunar White'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-white-belgian',
    name: 'Carrot - White Belgian',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'white standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['White Belgian'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-snow-white',
    name: 'Carrot - Snow White',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'white standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Snow White'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-purple-haze',
    name: 'Carrot - Purple Haze',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'purple standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Purple Haze'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-purple-dragon',
    name: 'Carrot - Purple Dragon',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'purple standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Purple Dragon'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-cosmic-purple',
    name: 'Carrot - Cosmic Purple',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'purple standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Cosmic Purple'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-deep-purple',
    name: 'Carrot - Deep Purple',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'purple standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Deep Purple'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-purple-sun',
    name: 'Carrot - Purple Sun',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'purple standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Purple Sun'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-yellowstone',
    name: 'Carrot - Yellowstone',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'yellow standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Yellowstone'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-yellow-sun',
    name: 'Carrot - Yellow Sun',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'yellow standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Yellow Sun'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-jaune-obtuse-du-doubs',
    name: 'Carrot - Jaune Obtuse du Doubs',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'yellow standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Jaune Obtuse du Doubs'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-amarillo',
    name: 'Carrot - Amarillo',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'yellow standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Amarillo'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-solar-yellow',
    name: 'Carrot - Solar Yellow',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'yellow standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Solar Yellow'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-atomic-red',
    name: 'Carrot - Atomic Red',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'red standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Atomic Red'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-red-samurai',
    name: 'Carrot - Red Samurai',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'red standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Red Samurai'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-kyoto-red',
    name: 'Carrot - Kyoto Red',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'red standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Kyoto Red'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-red-core-chantenay',
    name: 'Carrot - Red Core Chantenay',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'red-orange blocky carrot. Short, broad roots, good for clay soil. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Red Core Chantenay'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-little-finger',
    name: 'Carrot - Little Finger',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 8,
    daysToGermination: 14,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange round carrot. Round golf-ball shape, perfect for containers. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '2-3 inches',
    family: 'Apiaceae',
    varieties: ['Little Finger'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-parisienne',
    name: 'Carrot - Parisienne',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 8,
    daysToGermination: 14,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange round carrot. Round golf-ball shape, perfect for containers. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '2-3 inches',
    family: 'Apiaceae',
    varieties: ['Parisienne'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-paris-market',
    name: 'Carrot - Paris Market',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 8,
    daysToGermination: 14,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange round carrot. Round golf-ball shape, perfect for containers. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '2-3 inches',
    family: 'Apiaceae',
    varieties: ['Paris Market'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-romeo',
    name: 'Carrot - Romeo',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 8,
    daysToGermination: 14,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange round carrot. Round golf-ball shape, perfect for containers. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '2-3 inches',
    family: 'Apiaceae',
    varieties: ['Romeo'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-thumbelina',
    name: 'Carrot - Thumbelina',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 8,
    daysToGermination: 14,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange round carrot. Round golf-ball shape, perfect for containers. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '2-3 inches',
    family: 'Apiaceae',
    varieties: ['Thumbelina'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-round-romeo',
    name: 'Carrot - Round Romeo',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 8,
    daysToGermination: 14,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange round carrot. Round golf-ball shape, perfect for containers. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '2-3 inches',
    family: 'Apiaceae',
    varieties: ['Round Romeo'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-oxheart',
    name: 'Carrot - Oxheart',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Full size, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Oxheart'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-giant-belgium',
    name: 'Carrot - Giant Belgium',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Full size, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Giant Belgium'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-kuroda',
    name: 'Carrot - Kuroda',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Kuroda'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-shin-kuroda',
    name: 'Carrot - Shin Kuroda',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Shin Kuroda'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-kuroda-improved',
    name: 'Carrot - Kuroda Improved',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Kuroda Improved'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-kuroda-long',
    name: 'Carrot - Kuroda Long',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Kuroda Long'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-touchon',
    name: 'Carrot - Touchon',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Touchon'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-tendersweet',
    name: 'Carrot - Tendersweet',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Tendersweet'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-tendersnax',
    name: 'Carrot - Tendersnax',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Tendersnax'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  },
  {
    id: 'carrot-pioneer',
    name: 'Carrot - Pioneer',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion', 'radish', 'leek'],
    enemies: ['dill', 'parsnip'],
    description: 'orange standard carrot. Reliable garden carrot. Standard maturity.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Pioneer'],
    uses: ['fresh', 'cooking', 'juice', 'storage']
  }
,
  {
    id: 'pea-sugar-ann',
    name: 'Pea - Sugar Ann',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sugar Ann pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sugar Ann'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sugar-snap',
    name: 'Pea - Sugar Snap',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sugar Snap pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sugar Snap'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-super-sugar-snap',
    name: 'Pea - Super Sugar Snap',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Super Sugar Snap pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Super Sugar Snap'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-cascadia',
    name: 'Pea - Cascadia',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Cascadia pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Cascadia'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-mammoth-melting',
    name: 'Pea - Mammoth Melting',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Mammoth Melting pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Mammoth Melting'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-oregon-giant',
    name: 'Pea - Oregon Giant',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Oregon Giant pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Oregon Giant'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-oregon-sugar-pod-ii',
    name: 'Pea - Oregon Sugar Pod II',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Oregon Sugar Pod II pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Oregon Sugar Pod II'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-snowflake',
    name: 'Pea - Snowflake',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Snowflake pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Snowflake'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-dwarf-grey-sugar',
    name: 'Pea - Dwarf Grey Sugar',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Dwarf Grey Sugar pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Dwarf Grey Sugar'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-green-arrow',
    name: 'Pea - Green Arrow',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Green Arrow pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Green Arrow'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-little-marvel',
    name: 'Pea - Little Marvel',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Little Marvel pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Little Marvel'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-progress-no-9',
    name: 'Pea - Progress No 9',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Progress No 9 pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Progress No 9'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-wando',
    name: 'Pea - Wando',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Wando pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Wando'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-lincoln',
    name: 'Pea - Lincoln',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Lincoln pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Lincoln'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-tall-telephone',
    name: 'Pea - Tall Telephone',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Tall Telephone pea. Main crop, heavy producer. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Tall Telephone'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-alderman',
    name: 'Pea - Alderman',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Alderman pea. Main crop, heavy producer. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Alderman'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-maestro',
    name: 'Pea - Maestro',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Maestro pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Maestro'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-saber',
    name: 'Pea - Saber',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Saber pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Saber'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-knight',
    name: 'Pea - Knight',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Knight pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Knight'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sprinter',
    name: 'Pea - Sprinter',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sprinter pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sprinter'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-novella',
    name: 'Pea - Novella',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Novella pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Novella'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-bolero',
    name: 'Pea - Bolero',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Bolero pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Bolero'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-canoe',
    name: 'Pea - Canoe',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 68,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Canoe pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Canoe'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-catalyst',
    name: 'Pea - Catalyst',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Catalyst pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Catalyst'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-corne-de-belier',
    name: 'Pea - Corne de Belier',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Corne de Belier pea. Main crop, heavy producer. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Corne de Belier'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-feisty',
    name: 'Pea - Feisty',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Feisty pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Feisty'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-honey-snap',
    name: 'Pea - Honey Snap',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Honey Snap pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Honey Snap'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-hyper-tender',
    name: 'Pea - Hyper Tender',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Hyper Tender pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Hyper Tender'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-impact',
    name: 'Pea - Impact',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Impact pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Impact'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-java',
    name: 'Pea - Java',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Java pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Java'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-maxwell',
    name: 'Pea - Maxwell',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Maxwell pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Maxwell'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-meadow',
    name: 'Pea - Meadow',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Meadow pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Meadow'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-oasis',
    name: 'Pea - Oasis',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Oasis pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Oasis'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-premium',
    name: 'Pea - Premium',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Premium pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Premium'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-rally',
    name: 'Pea - Rally',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Rally pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Rally'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sienna',
    name: 'Pea - Sienna',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sienna pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sienna'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-striker',
    name: 'Pea - Striker',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Striker pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Striker'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sweetie',
    name: 'Pea - Sweetie',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sweetie pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sweetie'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-tremendous',
    name: 'Pea - Tremendous',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Tremendous pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Tremendous'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-ultra',
    name: 'Pea - Ultra',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Ultra pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Ultra'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-victory',
    name: 'Pea - Victory',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Victory pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Victory'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-wando',
    name: 'Pea - Wando',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Wando pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Wando'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-avalanche',
    name: 'Pea - Avalanche',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Avalanche pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Avalanche'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-beefeater',
    name: 'Pea - Beefeater',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Beefeater pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Beefeater'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-blizzard',
    name: 'Pea - Blizzard',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Blizzard pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Blizzard'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-bounty',
    name: 'Pea - Bounty',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Bounty pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Bounty'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-burpeeana-early',
    name: 'Pea - Burpeeana Early',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 56,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Burpeeana Early pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Burpeeana Early'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-caprice',
    name: 'Pea - Caprice',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Caprice pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Caprice'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-cascadia',
    name: 'Pea - Cascadia',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Cascadia pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Cascadia'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-dakota',
    name: 'Pea - Dakota',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Dakota pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Dakota'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-daybreak',
    name: 'Pea - Daybreak',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 56,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Daybreak pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Daybreak'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-easy-peasy',
    name: 'Pea - Easy Peasy',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Easy Peasy pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Easy Peasy'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-feisty',
    name: 'Pea - Feisty',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Feisty pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Feisty'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-green-beauty',
    name: 'Pea - Green Beauty',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Green Beauty pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Green Beauty'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-green-arrow-improved',
    name: 'Pea - Green Arrow Improved',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Green Arrow Improved pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Green Arrow Improved'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-homesteader',
    name: 'Pea - Homesteader',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Homesteader pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Homesteader'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-hyper-tendril',
    name: 'Pea - Hyper Tendril',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Hyper Tendril pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Hyper Tendril'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-knight',
    name: 'Pea - Knight',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Knight pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Knight'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-little-snappea',
    name: 'Pea - Little SnapPea',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Little SnapPea pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Little SnapPea'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-magnolia-blossom',
    name: 'Pea - Magnolia Blossom',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Magnolia Blossom pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Magnolia Blossom'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-misty',
    name: 'Pea - Misty',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Misty pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Misty'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-oregon-trail',
    name: 'Pea - Oregon Trail',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Oregon Trail pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Oregon Trail'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-penelope',
    name: 'Pea - Penelope',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Penelope pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Penelope'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-perfected',
    name: 'Pea - Perfected',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Perfected pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Perfected'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-piccolo-provenzale',
    name: 'Pea - Piccolo Provenzale',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Piccolo Provenzale pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Piccolo Provenzale'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-pioneer',
    name: 'Pea - Pioneer',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Pioneer pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Pioneer'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-premium',
    name: 'Pea - Premium',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Premium pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Premium'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-progress-9',
    name: 'Pea - Progress 9',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Progress 9 pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Progress 9'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-rascal',
    name: 'Pea - Rascal',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Rascal pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Rascal'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sabre',
    name: 'Pea - Sabre',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sabre pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sabre'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-schweizer-riesen',
    name: 'Pea - Schweizer Riesen',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Schweizer Riesen pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Schweizer Riesen'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-senator',
    name: 'Pea - Senator',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Senator pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Senator'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-snappy',
    name: 'Pea - Snappy',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Snappy pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Snappy'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-spring',
    name: 'Pea - Spring',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 56,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Spring pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Spring'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sugar-bon',
    name: 'Pea - Sugar Bon',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sugar Bon pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sugar Bon'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sugar-daddy',
    name: 'Pea - Sugar Daddy',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sugar Daddy pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sugar Daddy'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sugar-lace-ii',
    name: 'Pea - Sugar Lace II',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sugar Lace II pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sugar Lace II'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-sugar-sprint',
    name: 'Pea - Sugar Sprint',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 58,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Sugar Sprint pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sugar Sprint'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-super-snappy',
    name: 'Pea - Super Snappy',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Super Snappy pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Super Snappy'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-tall-climbing',
    name: 'Pea - Tall Climbing',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Tall Climbing pea. Main crop, heavy producer. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Tall Climbing'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-telephone',
    name: 'Pea - Telephone',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Telephone pea. Main crop, heavy producer. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Telephone'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-thomas-laxton',
    name: 'Pea - Thomas Laxton',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Thomas Laxton pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Thomas Laxton'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-tom-thumb',
    name: 'Pea - Tom Thumb',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Tom Thumb pea. Early variety, quick harvest. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Tom Thumb'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-trio',
    name: 'Pea - Trio',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Trio pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Trio'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-wando',
    name: 'Pea - Wando',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Wando pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Wando'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'pea-wonder',
    name: 'Pea - Wonder',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish', 'turnip'],
    enemies: ['onion', 'garlic'],
    description: 'Wonder pea. Reliable garden pea. Sweet flavor, perfect for fresh eating or freezing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Wonder'],
    uses: ['fresh', 'cooking', 'freezing']
  }
,
  {
    id: 'radish-cherry-belle',
    name: 'Radish - Cherry Belle',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Cherry Belle'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-champion',
    name: 'Radish - Champion',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 28,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Champion'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-crimson-giant',
    name: 'Radish - Crimson Giant',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 30,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Crimson Giant'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-early-scarlet-globe',
    name: 'Radish - Early Scarlet Globe',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 23,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Early Scarlet Globe'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-pink-beauty',
    name: 'Radish - Pink Beauty',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'pink round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Pink Beauty'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-rudolf',
    name: 'Radish - Rudolf',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Rudolf'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-sora',
    name: 'Radish - Sora',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Sora'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-rover',
    name: 'Radish - Rover',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 21,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Rover'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-crunchy-royale',
    name: 'Radish - Crunchy Royale',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Crunchy Royale'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-celesta',
    name: 'Radish - Celesta',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Celesta'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-nero-tondo',
    name: 'Radish - Nero Tondo',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 35,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'black round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Nero Tondo'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-black-spanish-round',
    name: 'Radish - Black Spanish Round',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'black round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Black Spanish Round'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-watermelon',
    name: 'Radish - Watermelon',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 30,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'green-pink round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Watermelon'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-green-meat',
    name: 'Radish - Green Meat',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 30,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'green round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Green Meat'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-misato-rose',
    name: 'Radish - Misato Rose',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 35,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'green-pink round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Misato Rose'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-red-meat',
    name: 'Radish - Red Meat',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 30,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red-white round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Red Meat'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-daikon',
    name: 'Radish - Daikon',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'white long radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Daikon'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-miyashige',
    name: 'Radish - Miyashige',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'white long radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Miyashige'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-minowase',
    name: 'Radish - Minowase',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'white long radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Minowase'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-shunkyo-semi-long',
    name: 'Radish - Shunkyo Semi-Long',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 35,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red-white long radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Shunkyo Semi-Long'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-french-breakfast',
    name: 'Radish - French Breakfast',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red-white elongated radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['French Breakfast'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-davignon',
    name: 'Radish - DAvignon',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red-white elongated radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['DAvignon'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-china-rose',
    name: 'Radish - China Rose',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red winter radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['China Rose'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-black-spanish-long',
    name: 'Radish - Black Spanish Long',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'black winter radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Black Spanish Long'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-german-giant',
    name: 'Radish - German Giant',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 30,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['German Giant'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-sicily-giant',
    name: 'Radish - Sicily Giant',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 35,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Sicily Giant'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-white-icicle',
    name: 'Radish - White Icicle',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 28,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'white long radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['White Icicle'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-snow-belle',
    name: 'Radish - Snow Belle',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'white round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Snow Belle'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-white-beauty',
    name: 'Radish - White Beauty',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'white round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['White Beauty'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-hailstone',
    name: 'Radish - Hailstone',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'white round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Hailstone'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-zlata',
    name: 'Radish - Zlata',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 30,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'yellow round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Zlata'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-helios',
    name: 'Radish - Helios',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 30,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'yellow round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Helios'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-easter-egg-ii',
    name: 'Radish - Easter Egg II',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 28,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'multi round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Easter Egg II'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-rainbow-mix',
    name: 'Radish - Rainbow Mix',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 28,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'multi round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Rainbow Mix'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-purple-plum',
    name: 'Radish - Purple Plum',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 28,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'purple round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Plum'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-malaga',
    name: 'Radish - Malaga',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 30,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'purple round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Malaga'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-amethyst',
    name: 'Radish - Amethyst',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 28,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'purple round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Amethyst'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-kn-bravo',
    name: 'Radish - KN-Bravo',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 35,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'purple-white round radish. Winter storage variety. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['KN-Bravo'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-saxa-2',
    name: 'Radish - Saxa 2',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 22,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Saxa 2'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-fuego',
    name: 'Radish - Fuego',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 23,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Fuego'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-red-king',
    name: 'Radish - Red King',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 28,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Red King'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-rover-f1',
    name: 'Radish - Rover F1',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 21,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Rover F1'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-cherriette',
    name: 'Radish - Cherriette',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 24,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Cherriette'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-rondar',
    name: 'Radish - Rondar',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Rondar'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-crunchy-crimson',
    name: 'Radish - Crunchy Crimson',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Crunchy Crimson'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-tinto',
    name: 'Radish - Tinto',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Tinto'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-diana',
    name: 'Radish - Diana',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Diana'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-raxe',
    name: 'Radish - Raxe',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 22,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Raxe'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-rivoli',
    name: 'Radish - Rivoli',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Rivoli'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-rover',
    name: 'Radish - Rover',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 21,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Rover'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-rudi',
    name: 'Radish - Rudi',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 22,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Rudi'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-scarlet-turnip-white-tip',
    name: 'Radish - Scarlet Turnip White Tip',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 28,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red-white round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Scarlet Turnip White Tip'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-sparkler',
    name: 'Radish - Sparkler',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red-white round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Sparkler'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-comet',
    name: 'Radish - Comet',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red-white round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Comet'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-red-boy',
    name: 'Radish - Red Boy',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Red Boy'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'radish-cherriette',
    name: 'Radish - Cherriette',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 24,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean', 'pea'],
    enemies: ['hyssop'],
    description: 'red round radish. Quick growing, ready in 3-4 weeks. Crisp and peppery.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Cherriette'],
    uses: ['fresh', 'salads', 'pickling']
  }
,
  {
    id: 'potato-yukon-gold',
    name: 'Potato - Yukon Gold',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Yukon Gold'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-kennebec',
    name: 'Potato - Kennebec',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Kennebec'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-red-pontiac',
    name: 'Potato - Red Pontiac',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Red Pontiac'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-russet-burbank',
    name: 'Potato - Russet Burbank',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Russet Burbank'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-norland',
    name: 'Potato - Norland',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Early variety, new potatoes in 60 days.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Norland'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-superior',
    name: 'Potato - Superior',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Superior'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-katahdin',
    name: 'Potato - Katahdin',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Katahdin'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-red-la-soda',
    name: 'Potato - Red La Soda',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Red La Soda'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-white-rose',
    name: 'Potato - White Rose',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['White Rose'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-gold-rush',
    name: 'Potato - Gold Rush',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Gold Rush'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-purple-majesty',
    name: 'Potato - Purple Majesty',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'purple specialty potato. Colorful specialty variety, high antioxidants. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Purple Majesty'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-all-blue',
    name: 'Potato - All Blue',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'blue specialty potato. Colorful specialty variety, high antioxidants. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['All Blue'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-russian-banana-fingerling',
    name: 'Potato - Russian Banana Fingerling',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'fingerling specialty potato. Small finger-shaped tubers, gourmet quality. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Russian Banana Fingerling'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-french-fingerling',
    name: 'Potato - French Fingerling',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'fingerling specialty potato. Small finger-shaped tubers, gourmet quality. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['French Fingerling'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-la-ratte',
    name: 'Potato - La Ratte',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'fingerling specialty potato. Small finger-shaped tubers, gourmet quality. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['La Ratte'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-rose-finn-apple',
    name: 'Potato - Rose Finn Apple',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'fingerling specialty potato. Small finger-shaped tubers, gourmet quality. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Rose Finn Apple'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-purple-peruvian',
    name: 'Potato - Purple Peruvian',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'fingerling specialty potato. Small finger-shaped tubers, gourmet quality. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Purple Peruvian'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-austrian-crescent',
    name: 'Potato - Austrian Crescent',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'fingerling specialty potato. Small finger-shaped tubers, gourmet quality. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Austrian Crescent'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-russian-banana',
    name: 'Potato - Russian Banana',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'fingerling specialty potato. Small finger-shaped tubers, gourmet quality. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Russian Banana'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-red-thumb',
    name: 'Potato - Red Thumb',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'fingerling specialty potato. Small finger-shaped tubers, gourmet quality. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Red Thumb'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-german-butterball',
    name: 'Potato - German Butterball',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['German Butterball'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-yellow-finn',
    name: 'Potato - Yellow Finn',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Yellow Finn'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-carola',
    name: 'Potato - Carola',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Carola'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-nicola',
    name: 'Potato - Nicola',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Nicola'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-bintje',
    name: 'Potato - Bintje',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Bintje'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-desiree',
    name: 'Potato - Desiree',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Desiree'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-chieftain',
    name: 'Potato - Chieftain',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Chieftain'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-viking-red',
    name: 'Potato - Viking Red',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Viking Red'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-dark-red-norland',
    name: 'Potato - Dark Red Norland',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Early variety, new potatoes in 60 days.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Dark Red Norland'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-red-gold',
    name: 'Potato - Red Gold',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Red Gold'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-adirondack-red',
    name: 'Potato - Adirondack Red',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Adirondack Red'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-adirondack-blue',
    name: 'Potato - Adirondack Blue',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'blue specialty potato. Colorful specialty variety, high antioxidants. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Adirondack Blue'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-all-red',
    name: 'Potato - All Red',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['All Red'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-all-blue',
    name: 'Potato - All Blue',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'blue specialty potato. Colorful specialty variety, high antioxidants. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['All Blue'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-caribe',
    name: 'Potato - Caribe',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'purple specialty potato. Colorful specialty variety, high antioxidants. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Caribe'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-elba',
    name: 'Potato - Elba',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Elba'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-green-mountain',
    name: 'Potato - Green Mountain',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Green Mountain'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-irish-cobbler',
    name: 'Potato - Irish Cobbler',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Irish Cobbler'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-kerr-pink',
    name: 'Potato - Kerr Pink',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'pink all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Kerr Pink'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-king-harry',
    name: 'Potato - King Harry',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['King Harry'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-maris-piper',
    name: 'Potato - Maris Piper',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Maris Piper'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-norkotah',
    name: 'Potato - Norkotah',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Norkotah'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-penta',
    name: 'Potato - Penta',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Penta'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-purple-viking',
    name: 'Potato - Purple Viking',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'purple specialty potato. Colorful specialty variety, high antioxidants. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Purple Viking'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-ranger-russet',
    name: 'Potato - Ranger Russet',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Ranger Russet'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-reba',
    name: 'Potato - Reba',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Reba'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-reddale',
    name: 'Potato - Reddale',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Reddale'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-red-maria',
    name: 'Potato - Red Maria',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Red Maria'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-rose-gold',
    name: 'Potato - Rose Gold',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Rose Gold'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-satina',
    name: 'Potato - Satina',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Satina'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-sierra-gold',
    name: 'Potato - Sierra Gold',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Sierra Gold'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-snowden',
    name: 'Potato - Snowden',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Snowden'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-viking',
    name: 'Potato - Viking',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'purple specialty potato. Colorful specialty variety, high antioxidants. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Viking'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-warba',
    name: 'Potato - Warba',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Early variety, new potatoes in 60 days.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Warba'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-yellowstone',
    name: 'Potato - Yellowstone',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Yellowstone'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-yukon-gem',
    name: 'Potato - Yukon Gem',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Yukon Gem'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-alturas',
    name: 'Potato - Alturas',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Alturas'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-atlantic',
    name: 'Potato - Atlantic',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Atlantic'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-belmonda',
    name: 'Potato - Belmonda',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Belmonda'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-blossom',
    name: 'Potato - Blossom',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Blossom'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-butte',
    name: 'Potato - Butte',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Butte'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-centennial-russet',
    name: 'Potato - Centennial Russet',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Centennial Russet'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-defender',
    name: 'Potato - Defender',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Defender'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-early-rose',
    name: 'Potato - Early Rose',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'pink all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Early Rose'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-eramosa',
    name: 'Potato - Eramosa',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Eramosa'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-eva',
    name: 'Potato - Eva',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Eva'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-freedom-russet',
    name: 'Potato - Freedom Russet',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Freedom Russet'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-goldmarble',
    name: 'Potato - Goldmarble',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Goldmarble'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-huckleberry-gold',
    name: 'Potato - Huckleberry Gold',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'purple specialty potato. Colorful specialty variety, high antioxidants. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Huckleberry Gold'],
    uses: ['roasting', 'salads', 'gourmet']
  },
  {
    id: 'potato-innovator',
    name: 'Potato - Innovator',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'russet baking potato. High starch, perfect for baking and fries. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Innovator'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-jelly',
    name: 'Potato - Jelly',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'red all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Jelly'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-keuka-gold',
    name: 'Potato - Keuka Gold',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Keuka Gold'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-lamoka',
    name: 'Potato - Lamoka',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Lamoka'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-lehigh',
    name: 'Potato - Lehigh',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'yellow all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Lehigh'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-liberator',
    name: 'Potato - Liberator',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Liberator'],
    uses: ['boiling', 'roasting', 'mashed']
  },
  {
    id: 'potato-maine-chip',
    name: 'Potato - Maine Chip',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn', 'cabbage'],
    enemies: ['tomato', 'sunflower', 'potato'],
    description: 'white all-purpose potato. Versatile all-purpose potato. Main crop, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Maine Chip'],
    uses: ['boiling', 'roasting', 'mashed']
  }
,
  {
    id: 'beet-detroit-dark-red',
    name: 'Beet - Detroit Dark Red',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Detroit Dark Red'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-detroit-supreme',
    name: 'Beet - Detroit Supreme',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Detroit Supreme'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-early-wonder',
    name: 'Beet - Early Wonder',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Early Wonder'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-cylindra',
    name: 'Beet - Cylindra',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Cylindra'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-chioggia',
    name: 'Beet - Chioggia',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'striped beet. Beautiful candy cane rings when sliced. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Chioggia'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-golden',
    name: 'Beet - Golden',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'yellow beet. Mild flavor, no bleeding, golden color. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Golden'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-touchstone-gold',
    name: 'Beet - Touchstone Gold',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'yellow beet. Mild flavor, no bleeding, golden color. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Touchstone Gold'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-bull-blood',
    name: 'Beet - Bull Blood',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Bull Blood'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-albino',
    name: 'Beet - Albino',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'white beet. Mild and sweet, no staining. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Albino'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-avalanche',
    name: 'Beet - Avalanche',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'white beet. Mild and sweet, no staining. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Avalanche'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-boldor',
    name: 'Beet - Boldor',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'yellow beet. Mild flavor, no bleeding, golden color. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Boldor'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-boro',
    name: 'Beet - Boro',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Boro'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-carillon',
    name: 'Beet - Carillon',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Carillon'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-crosby-egyptian',
    name: 'Beet - Crosby Egyptian',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Crosby Egyptian'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-cylindra',
    name: 'Beet - Cylindra',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Cylindra'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-dark-red',
    name: 'Beet - Dark Red',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Dark Red'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-egyptian-flat',
    name: 'Beet - Egyptian Flat',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Egyptian Flat'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-forono',
    name: 'Beet - Forono',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Forono'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-formanova',
    name: 'Beet - Formanova',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Formanova'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-gladiator',
    name: 'Beet - Gladiator',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Gladiator'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-golden-detroit',
    name: 'Beet - Golden Detroit',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'yellow beet. Mild flavor, no bleeding, golden color. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Golden Detroit'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-gourmet-golden',
    name: 'Beet - Gourmet Golden',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'yellow beet. Mild flavor, no bleeding, golden color. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Gourmet Golden'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-green-top-bunching',
    name: 'Beet - Green Top Bunching',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Green Top Bunching'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-high-mowing',
    name: 'Beet - High Mowing',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['High Mowing'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-iceberg',
    name: 'Beet - Iceberg',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'white beet. Mild and sweet, no staining. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Iceberg'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-jaunee-d-or',
    name: 'Beet - Jaunee d Or',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'yellow beet. Mild flavor, no bleeding, golden color. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Jaunee d Or'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-kestrel',
    name: 'Beet - Kestrel',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Kestrel'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-larka',
    name: 'Beet - Larka',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Larka'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-lutz-green-leaf',
    name: 'Beet - Lutz Green Leaf',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Large storage beet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Lutz Green Leaf'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-merlin',
    name: 'Beet - Merlin',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Merlin'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-mokum',
    name: 'Beet - Mokum',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Mokum'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-mona',
    name: 'Beet - Mona',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Mona'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-moneta',
    name: 'Beet - Moneta',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Moneta'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-monorubra',
    name: 'Beet - Monorubra',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Monorubra'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-nero',
    name: 'Beet - Nero',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Nero'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-pacemaker-iii',
    name: 'Beet - Pacemaker III',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Pacemaker III'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-perfected-detroit',
    name: 'Beet - Perfected Detroit',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Perfected Detroit'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-pablo',
    name: 'Beet - Pablo',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Pablo'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-red-ace',
    name: 'Beet - Red Ace',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Red Ace'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-red-cloud',
    name: 'Beet - Red Cloud',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Red Cloud'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-ruby-queen',
    name: 'Beet - Ruby Queen',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Ruby Queen'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-sanguina',
    name: 'Beet - Sanguina',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Sanguina'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-scarlet-supreme',
    name: 'Beet - Scarlet Supreme',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Scarlet Supreme'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-subeto',
    name: 'Beet - Subeto',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Subeto'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-touchstone-gold',
    name: 'Beet - Touchstone Gold',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'yellow beet. Mild flavor, no bleeding, golden color. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Touchstone Gold'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-warrior',
    name: 'Beet - Warrior',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Warrior'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-yellow-cylindra',
    name: 'Beet - Yellow Cylindra',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'yellow beet. Mild flavor, no bleeding, golden color. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Yellow Cylindra'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  },
  {
    id: 'beet-zeppo',
    name: 'Beet - Zeppo',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce', 'cabbage'],
    enemies: ['mustard', 'charlock'],
    description: 'red beet. Classic dark red, earthy sweet flavor. Tender baby beet size.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Zeppo'],
    uses: ['roasting', 'pickling', 'salads', 'greens', 'juice']
  }
,
  {
    id: 'turnip-purple-top-white-globe',
    name: 'Turnip - Purple Top White Globe',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Purple Top White Globe turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Top White Globe'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-white-egg',
    name: 'Turnip - White Egg',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'White Egg turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['White Egg'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'salad-hakurei',
    name: 'Salad - Hakurei',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Hakurei salad. Small tender roots, harvest young for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Hakurei'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'salad-tokyo-cross',
    name: 'Salad - Tokyo Cross',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 35,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Tokyo Cross salad. Small tender roots, harvest young for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Tokyo Cross'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-just-right',
    name: 'Turnip - Just Right',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Just Right turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Just Right'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-shogoin',
    name: 'Turnip - Shogoin',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Shogoin turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Shogoin'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'greens-seven-top',
    name: 'Greens - Seven Top',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Seven Top greens. Grown for leafy tops, not root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Seven Top'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'greens-topper',
    name: 'Greens - Topper',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Topper greens. Grown for leafy tops, not root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Topper'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'greens-alltop',
    name: 'Greens - Alltop',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Alltop greens. Grown for leafy tops, not root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Alltop'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-purple-top-milan',
    name: 'Turnip - Purple Top Milan',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Purple Top Milan turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Top Milan'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'red-scarlet-queen',
    name: 'Red - Scarlet Queen',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Scarlet Queen red. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Scarlet Queen'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'yellow-golden-ball',
    name: 'Yellow - Golden Ball',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Golden Ball yellow. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Ball'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'yellow-amber-globe',
    name: 'Yellow - Amber Globe',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Amber Globe yellow. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Amber Globe'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'white-milan-white',
    name: 'White - Milan White',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Milan White white. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Milan White'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'white-navet-de-vertus',
    name: 'White - Navet de Vertus',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Navet de Vertus white. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Navet de Vertus'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-oasis',
    name: 'Turnip - Oasis',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Oasis turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Oasis'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-petrowsky',
    name: 'Turnip - Petrowsky',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Petrowsky turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Petrowsky'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-purple-prince',
    name: 'Turnip - Purple Prince',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Purple Prince turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Prince'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-red-round',
    name: 'Turnip - Red Round',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Red Round turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Red Round'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-royal-crown',
    name: 'Turnip - Royal Crown',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Royal Crown turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Royal Crown'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'white-snow-ball',
    name: 'White - Snow Ball',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Snow Ball white. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Snow Ball'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'turnip-tokyo-market',
    name: 'Turnip - Tokyo Market',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Tokyo Market turnip. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Tokyo Market'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'white-white-lady',
    name: 'White - White Lady',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'White Lady white. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['White Lady'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'yellow-yellow-globe',
    name: 'Yellow - Yellow Globe',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 5,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Yellow Globe yellow. Classic purple top, white flesh, versatile cooking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow Globe'],
    uses: ['cooking', 'roasting', 'raw', 'greens']
  },
  {
    id: 'rutabaga-laurentian',
    name: 'Rutabaga - Laurentian',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Laurentian rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Laurentian'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-american-purple-top',
    name: 'Rutabaga - American Purple Top',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'American Purple Top rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['American Purple Top'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-joan',
    name: 'Rutabaga - Joan',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Joan rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Joan'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-marian',
    name: 'Rutabaga - Marian',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Marian rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Marian'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-nadmorska',
    name: 'Rutabaga - Nadmorska',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Nadmorska rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Nadmorska'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-pike',
    name: 'Rutabaga - Pike',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Pike rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Pike'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-ruby',
    name: 'Rutabaga - Ruby',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Ruby rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Ruby'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-wilhelmsburger',
    name: 'Rutabaga - Wilhelmsburger',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Wilhelmsburger rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Wilhelmsburger'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-york',
    name: 'Rutabaga - York',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'York rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['York'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-bronze-top',
    name: 'Rutabaga - Bronze Top',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Bronze Top rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Bronze Top'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-gold-ball',
    name: 'Rutabaga - Gold Ball',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Gold Ball rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Gold Ball'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-improved-long-island',
    name: 'Rutabaga - Improved Long Island',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Improved Long Island rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Improved Long Island'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-long-island-improved',
    name: 'Rutabaga - Long Island Improved',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Long Island Improved rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Long Island Improved'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-macomber',
    name: 'Rutabaga - Macomber',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Macomber rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Macomber'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-perfected',
    name: 'Rutabaga - Perfected',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Perfected rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Perfected'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  },
  {
    id: 'rutabaga-red-chief',
    name: 'Rutabaga - Red Chief',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 18,
    daysToGermination: 5,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['pea'],
    enemies: ['horseradish'],
    description: 'Red Chief rutabaga. Large yellow root, sweet and nutty, excellent storage crop.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Red Chief'],
    uses: ['roasting', 'mashing', 'soup', 'storage']
  }
,
  {
    id: 'eggplant-black-beauty',
    name: 'Eggplant - Black Beauty',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'black eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Beauty'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-ichiban',
    name: 'Eggplant - Ichiban',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Ichiban'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-long-purple',
    name: 'Eggplant - Long Purple',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Long Purple'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-rosa-bianca',
    name: 'Eggplant - Rosa Bianca',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'white eggplant. Unique white fruit, mild and creamy. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Rosa Bianca'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-listada-de-gandia',
    name: 'Eggplant - Listada de Gandia',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'striped eggplant. Beautiful striped or variegated skin. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Listada de Gandia'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-fairy-tale',
    name: 'Eggplant - Fairy Tale',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple-white eggplant. Beautiful striped or variegated skin. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Fairy Tale'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-hansel',
    name: 'Eggplant - Hansel',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Hansel'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-gretel',
    name: 'Eggplant - Gretel',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'white eggplant. Unique white fruit, mild and creamy. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Gretel'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-beatrice',
    name: 'Eggplant - Beatrice',
    scientificName: 'Solanum melongena',
    category: 'grain',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'lavender eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Beatrice'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-nadia',
    name: 'Eggplant - Nadia',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Nadia'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-orient-express',
    name: 'Eggplant - Orient Express',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Orient Express'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-millionaire',
    name: 'Eggplant - Millionaire',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Millionaire'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-classic',
    name: 'Eggplant - Classic',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Classic'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-dusky',
    name: 'Eggplant - Dusky',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Dusky'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-epic',
    name: 'Eggplant - Epic',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Epic'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-traviata',
    name: 'Eggplant - Traviata',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Traviata'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-calliope',
    name: 'Eggplant - Calliope',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple-white eggplant. Beautiful striped or variegated skin. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Calliope'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-annina',
    name: 'Eggplant - Annina',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Annina'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-aretussa',
    name: 'Eggplant - Aretussa',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'white eggplant. Unique white fruit, mild and creamy. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Aretussa'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-aubergine',
    name: 'Eggplant - Aubergine',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Aubergine'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-barbarella',
    name: 'Eggplant - Barbarella',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Barbarella'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-black-enigma',
    name: 'Eggplant - Black Enigma',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'black eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Enigma'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-black-king',
    name: 'Eggplant - Black King',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'black eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black King'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-black-magic',
    name: 'Eggplant - Black Magic',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'black eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Magic'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-bonica',
    name: 'Eggplant - Bonica',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Bonica'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-casper',
    name: 'Eggplant - Casper',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'white eggplant. Unique white fruit, mild and creamy. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Casper'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-clara',
    name: 'Eggplant - Clara',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'white eggplant. Unique white fruit, mild and creamy. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Clara'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-cloud-nine',
    name: 'Eggplant - Cloud Nine',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'white eggplant. Unique white fruit, mild and creamy. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Cloud Nine'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-comet',
    name: 'Eggplant - Comet',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Comet'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-diamond',
    name: 'Eggplant - Diamond',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Diamond'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-easter-egg',
    name: 'Eggplant - Easter Egg',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'mixed eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Easter Egg'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-fengyuan-purple',
    name: 'Eggplant - Fengyuan Purple',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Fengyuan Purple'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-galine',
    name: 'Eggplant - Galine',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Galine'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-gaudi',
    name: 'Eggplant - Gaudi',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Gaudi'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-ghostbuster',
    name: 'Eggplant - Ghostbuster',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'white eggplant. Unique white fruit, mild and creamy. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Ghostbuster'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-graffiti',
    name: 'Eggplant - Graffiti',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Graffiti'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-halep',
    name: 'Eggplant - Halep',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Halep'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-japanese-white',
    name: 'Eggplant - Japanese White',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'white eggplant. Unique white fruit, mild and creamy. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Japanese White'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-kermit',
    name: 'Eggplant - Kermit',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'green eggplant. Traditional Thai green variety. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Kermit'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  },
  {
    id: 'eggplant-little-fingers',
    name: 'Eggplant - Little Fingers',
    scientificName: 'Solanum melongena',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5.5,
    phMax: 6.5,
    companions: ['bean', 'pepper', 'marigold'],
    enemies: ['fennel'],
    description: 'purple eggplant. Classic dark purple, versatile for cooking. Heat loving, start indoors early.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Little Fingers'],
    uses: ['grilling', 'roasting', 'parmesan', 'ratatouille', 'asian cuisine']
  }
,
  {
    id: 'parsnip-hollow-crown',
    name: 'Parsnip - Hollow Crown',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Hollow Crown parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Hollow Crown'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-all-american',
    name: 'Celeriac - All American',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'All American celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['All American'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-javelin',
    name: 'Horseradish - Javelin',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Javelin horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Javelin'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-gladiator',
    name: 'Salsify - Gladiator',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gladiator salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Gladiator'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-lancer',
    name: 'Scorzonera - Lancer',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lancer scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lancer'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-turga',
    name: 'Taro - Turga',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turga taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Turga'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-andover',
    name: 'Yuca - Andover',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Andover yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Andover'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-albion',
    name: 'Jerusalem artichoke - Albion',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Albion jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Albion'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-dagger',
    name: 'Daikon - Dagger',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dagger daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Dagger'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-panache',
    name: 'Rutabaga - Panache',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panache rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Panache'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-brilliant',
    name: 'Parsnip - Brilliant',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Brilliant parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Brilliant'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-monarch',
    name: 'Celeriac - Monarch',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Monarch celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Monarch'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-prinz',
    name: 'Horseradish - Prinz',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prinz horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Prinz'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-snow-white',
    name: 'Salsify - Snow White',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Snow White salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Snow White'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-tellus',
    name: 'Scorzonera - Tellus',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tellus scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tellus'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-victoria',
    name: 'Taro - Victoria',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Victoria taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Victoria'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-giant-prague',
    name: 'Yuca - Giant Prague',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant Prague yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Giant Prague'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-diamant',
    name: 'Jerusalem artichoke - Diamant',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Diamant jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Diamant'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-ibis',
    name: 'Daikon - Ibis',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ibis daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ibis'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-maxim',
    name: 'Rutabaga - Maxim',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maxim rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Maxim'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-mars',
    name: 'Parsnip - Mars',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Mars parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Mars'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-novella',
    name: 'Celeriac - Novella',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Novella celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Novella'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-soprano',
    name: 'Horseradish - Soprano',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soprano horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Soprano'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-alabaster',
    name: 'Salsify - Alabaster',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alabaster salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Alabaster'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-asterix',
    name: 'Scorzonera - Asterix',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Asterix scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Asterix'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-bohemia',
    name: 'Taro - Bohemia',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bohemia taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Bohemia'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-celio',
    name: 'Yuca - Celio',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celio yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Celio'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-celeriac',
    name: 'Jerusalem artichoke - Celeriac',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celeriac jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Celeriac'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-celine',
    name: 'Daikon - Celine',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celine daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Celine'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-ceres',
    name: 'Rutabaga - Ceres',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ceres rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ceres'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-cesar',
    name: 'Parsnip - Cesar',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Cesar parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cesar'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-cobalt',
    name: 'Celeriac - Cobalt',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Cobalt celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cobalt'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-dolvi',
    name: 'Horseradish - Dolvi',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dolvi horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Dolvi'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-gildor',
    name: 'Salsify - Gildor',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gildor salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Gildor'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-iram',
    name: 'Scorzonera - Iram',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Iram scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Iram'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-kariba',
    name: 'Taro - Kariba',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kariba taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Kariba'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-kojak',
    name: 'Yuca - Kojak',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kojak yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Kojak'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-monarch',
    name: 'Jerusalem artichoke - Monarch',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monarch jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Monarch'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-prague',
    name: 'Daikon - Prague',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prague daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Prague'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-regent',
    name: 'Rutabaga - Regent',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Regent rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Regent'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-sedan',
    name: 'Parsnip - Sedan',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Sedan parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Sedan'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-tellus',
    name: 'Celeriac - Tellus',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Tellus celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Tellus'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-titus',
    name: 'Horseradish - Titus',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Titus horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Titus'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-velt',
    name: 'Salsify - Velt',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Velt salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Velt'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-victoria',
    name: 'Scorzonera - Victoria',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Victoria scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Victoria'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-malanga',
    name: 'Taro - Malanga',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Malanga taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Malanga'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-coco-yam',
    name: 'Yuca - Coco Yam',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Coco Yam yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Coco Yam'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-eddoe',
    name: 'Jerusalem artichoke - Eddoe',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eddoe jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Eddoe'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-dasheen',
    name: 'Daikon - Dasheen',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dasheen daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Dasheen'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-chinese',
    name: 'Rutabaga - Chinese',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Chinese'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-lehua',
    name: 'Parsnip - Lehua',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Lehua parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Lehua'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-bun-long',
    name: 'Celeriac - Bun Long',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Bun Long celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Bun Long'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-maui-lehua',
    name: 'Horseradish - Maui Lehua',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maui Lehua horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Maui Lehua'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-kalo',
    name: 'Salsify - Kalo',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kalo salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Kalo'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-tahitian',
    name: 'Scorzonera - Tahitian',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tahitian scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tahitian'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-white',
    name: 'Taro - White',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['White'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-yellow',
    name: 'Yuca - Yellow',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Yellow'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-sweet',
    name: 'Jerusalem artichoke - Sweet',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sweet'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-bitter',
    name: 'Daikon - Bitter',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Bitter'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-manioc',
    name: 'Rutabaga - Manioc',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Manioc rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Manioc'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-yuca-root',
    name: 'Parsnip - Yuca Root',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Yuca Root parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Yuca Root'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-cassava',
    name: 'Celeriac - Cassava',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Cassava celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cassava'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-tapioca',
    name: 'Horseradish - Tapioca',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tapioca horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Tapioca'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-brazilian-arrowroot',
    name: 'Salsify - Brazilian Arrowroot',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brazilian Arrowroot salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Brazilian Arrowroot'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-manioc-meal',
    name: 'Scorzonera - Manioc Meal',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Manioc Meal scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Manioc Meal'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-mashua',
    name: 'Taro - Mashua',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mashua taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Mashua'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-anu',
    name: 'Yuca - Anu',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Anu yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Anu'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-cubio',
    name: 'Jerusalem artichoke - Cubio',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cubio jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Cubio'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-tuberous-nasturtium',
    name: 'Daikon - Tuberous Nasturtium',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tuberous Nasturtium daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tuberous Nasturtium'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-tropaeolum',
    name: 'Rutabaga - Tropaeolum',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tropaeolum rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tropaeolum'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-oca',
    name: 'Parsnip - Oca',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Oca parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Oca'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-new-zealand-yam',
    name: 'Celeriac - New Zealand Yam',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'New Zealand Yam celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['New Zealand Yam'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-oxalis',
    name: 'Horseradish - Oxalis',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oxalis horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Oxalis'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-wood-sorrel',
    name: 'Salsify - Wood Sorrel',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wood Sorrel salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Wood Sorrel'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-uqa',
    name: 'Scorzonera - Uqa',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Uqa scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Uqa'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-ulluco',
    name: 'Taro - Ulluco',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ulluco taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Ulluco'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-papa-lisa',
    name: 'Yuca - Papa Lisa',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Papa Lisa yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Papa Lisa'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-melloco',
    name: 'Jerusalem artichoke - Melloco',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Melloco jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Melloco'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-ruba',
    name: 'Daikon - Ruba',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruba daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ruba'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-chugua',
    name: 'Rutabaga - Chugua',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chugua rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Chugua'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-yacon',
    name: 'Parsnip - Yacon',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Yacon parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Yacon'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-apple-of-the-earth',
    name: 'Celeriac - Apple of the Earth',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Apple of the Earth celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Apple of the Earth'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-bolivian-sunroot',
    name: 'Horseradish - Bolivian Sunroot',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bolivian Sunroot horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Bolivian Sunroot'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-smallanthus',
    name: 'Salsify - Smallanthus',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smallanthus salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Smallanthus'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-sunroot',
    name: 'Scorzonera - Sunroot',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sunroot scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sunroot'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-maca',
    name: 'Taro - Maca',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maca taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Maca'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-peruvian-ginseng',
    name: 'Yuca - Peruvian Ginseng',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peruvian Ginseng yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Peruvian Ginseng'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-lepidium',
    name: 'Jerusalem artichoke - Lepidium',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lepidium jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lepidium'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-maka',
    name: 'Daikon - Maka',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maka daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Maka'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-andean',
    name: 'Rutabaga - Andean',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Andean rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Andean'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-chinese-artichoke',
    name: 'Parsnip - Chinese Artichoke',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Chinese Artichoke parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Chinese Artichoke'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-crosne',
    name: 'Celeriac - Crosne',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Crosne celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Crosne'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-japanese-artichoke',
    name: 'Horseradish - Japanese Artichoke',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese Artichoke horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Japanese Artichoke'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-knotroot',
    name: 'Salsify - Knotroot',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Knotroot salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Knotroot'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-artichoke-betony',
    name: 'Scorzonera - Artichoke Betony',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Artichoke Betony scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Artichoke Betony'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-salsify',
    name: 'Taro - Salsify',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Salsify taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Salsify'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-oyster-plant',
    name: 'Yuca - Oyster Plant',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oyster Plant yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Oyster Plant'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-vegetable-oyster',
    name: 'Jerusalem artichoke - Vegetable Oyster',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vegetable Oyster jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Vegetable Oyster'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-goatsbeard',
    name: 'Daikon - Goatsbeard',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'grain',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Goatsbeard daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Goatsbeard'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-tragopogon',
    name: 'Rutabaga - Tragopogon',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tragopogon rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tragopogon'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-scorzonera',
    name: 'Parsnip - Scorzonera',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Scorzonera parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Scorzonera'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-black-salsify',
    name: 'Celeriac - Black Salsify',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Black Salsify celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Black Salsify'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-viper-grass',
    name: 'Horseradish - Viper Grass',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Viper Grass horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Viper Grass'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-spanish-salsify',
    name: 'Salsify - Spanish Salsify',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Salsify salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Spanish Salsify'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-scorzonera-hispanica',
    name: 'Scorzonera - Scorzonera Hispanica',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Scorzonera Hispanica scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Scorzonera Hispanica'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-skirret',
    name: 'Taro - Skirret',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Skirret taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Skirret'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-water-parsnip',
    name: 'Yuca - Water Parsnip',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Water Parsnip yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Water Parsnip'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-sium',
    name: 'Jerusalem artichoke - Sium',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sium jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sium'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-crummock',
    name: 'Daikon - Crummock',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crummock daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Crummock'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-sium-sisarum',
    name: 'Rutabaga - Sium Sisarum',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sium Sisarum rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sium Sisarum'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-hamburg-parsley',
    name: 'Parsnip - Hamburg Parsley',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Hamburg Parsley parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Hamburg Parsley'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-turnip-rooted',
    name: 'Celeriac - Turnip Rooted',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Turnip Rooted celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Turnip Rooted'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-parsnip-rooted',
    name: 'Horseradish - Parsnip Rooted',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Parsnip Rooted horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Parsnip Rooted'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-hamburg',
    name: 'Salsify - Hamburg',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hamburg salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Hamburg'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-root-parsley',
    name: 'Scorzonera - Root Parsley',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Root Parsley scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Root Parsley'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-arracacha',
    name: 'Taro - Arracacha',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arracacha taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Arracacha'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-white-carrot',
    name: 'Yuca - White Carrot',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Carrot yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['White Carrot'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-peruvian-parsnip',
    name: 'Jerusalem artichoke - Peruvian Parsnip',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peruvian Parsnip jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Peruvian Parsnip'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-apio',
    name: 'Daikon - Apio',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apio daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Apio'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-arracacia',
    name: 'Rutabaga - Arracacia',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arracacia rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Arracacia'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-pignut',
    name: 'Parsnip - Pignut',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Pignut parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Pignut'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-earth-nut',
    name: 'Celeriac - Earth Nut',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Earth Nut celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Earth Nut'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-conopodium',
    name: 'Horseradish - Conopodium',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Conopodium horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Conopodium'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-kippernut',
    name: 'Salsify - Kippernut',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kippernut salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Kippernut'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-hognut',
    name: 'Scorzonera - Hognut',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hognut scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Hognut'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-chufa',
    name: 'Taro - Chufa',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chufa taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Chufa'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-tiger-nut',
    name: 'Yuca - Tiger Nut',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tiger Nut yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Tiger Nut'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-yellow-nut-sedge',
    name: 'Jerusalem artichoke - Yellow Nut Sedge',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Nut Sedge jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Yellow Nut Sedge'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-cyperus',
    name: 'Daikon - Cyperus',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cyperus daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Cyperus'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-zulu-nut',
    name: 'Rutabaga - Zulu Nut',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zulu Nut rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Zulu Nut'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-lotus-root',
    name: 'Parsnip - Lotus Root',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Lotus Root parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Lotus Root'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-renkon',
    name: 'Celeriac - Renkon',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Renkon celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Renkon'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-nelumbo',
    name: 'Horseradish - Nelumbo',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nelumbo horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Nelumbo'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-sacred-lotus',
    name: 'Salsify - Sacred Lotus',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sacred Lotus salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sacred Lotus'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-hasu',
    name: 'Scorzonera - Hasu',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hasu scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Hasu'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-wasabi',
    name: 'Taro - Wasabi',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wasabi taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Wasabi'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-japanese-horseradish',
    name: 'Yuca - Japanese Horseradish',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese Horseradish yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Japanese Horseradish'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-eutrema',
    name: 'Jerusalem artichoke - Eutrema',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eutrema jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Eutrema'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-wasabia',
    name: 'Daikon - Wasabia',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wasabia daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Wasabia'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-kona',
    name: 'Rutabaga - Kona',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kona rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Kona'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-horseradish',
    name: 'Parsnip - Horseradish',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Horseradish parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Horseradish'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-red-cole',
    name: 'Celeriac - Red Cole',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Red Cole celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Red Cole'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-armoracia',
    name: 'Horseradish - Armoracia',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Armoracia horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Armoracia'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-horse-radish',
    name: 'Salsify - Horse Radish',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Horse Radish salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Horse Radish'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-cren',
    name: 'Scorzonera - Cren',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cren scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Cren'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-daikon',
    name: 'Taro - Daikon',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Daikon'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-white-radish',
    name: 'Yuca - White Radish',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Radish yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['White Radish'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-japanese-radish',
    name: 'Jerusalem artichoke - Japanese Radish',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese Radish jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Japanese Radish'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-oriental-radish',
    name: 'Daikon - Oriental Radish',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oriental Radish daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Oriental Radish'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-mooli',
    name: 'Rutabaga - Mooli',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mooli rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Mooli'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-watermelon-radish',
    name: 'Parsnip - Watermelon Radish',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Watermelon Radish parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Watermelon Radish'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-red-meat',
    name: 'Celeriac - Red Meat',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Red Meat celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Red Meat'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-beauty-heart',
    name: 'Horseradish - Beauty Heart',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Beauty Heart horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Beauty Heart'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-shinrimei',
    name: 'Salsify - Shinrimei',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shinrimei salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Shinrimei'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-xin-li-mei',
    name: 'Scorzonera - Xin Li Mei',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Xin Li Mei scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Xin Li Mei'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-black-radish',
    name: 'Taro - Black Radish',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Radish taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Black Radish'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-spanish-radish',
    name: 'Yuca - Spanish Radish',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Radish yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Spanish Radish'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-gros-noir',
    name: 'Jerusalem artichoke - Gros Noir',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gros Noir jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Gros Noir'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-noir-gros',
    name: 'Daikon - Noir Gros',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Noir Gros daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Noir Gros'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-raphanus',
    name: 'Rutabaga - Raphanus',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Raphanus rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Raphanus'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-icicle-radish',
    name: 'Parsnip - Icicle Radish',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Icicle Radish parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Icicle Radish'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-white-icicle',
    name: 'Celeriac - White Icicle',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'White Icicle celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['White Icicle'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-long-white',
    name: 'Horseradish - Long White',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long White horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Long White'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-lady-finger',
    name: 'Salsify - Lady Finger',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lady Finger salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lady Finger'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-daikon-type',
    name: 'Scorzonera - Daikon Type',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon Type scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Daikon Type'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-easter-egg',
    name: 'Taro - Easter Egg',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Easter Egg taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Easter Egg'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-rainbow',
    name: 'Yuca - Rainbow',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rainbow yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Rainbow'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-easter-egg-ii',
    name: 'Jerusalem artichoke - Easter Egg II',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Easter Egg II jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Easter Egg II'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-multicolor',
    name: 'Daikon - Multicolor',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multicolor daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Multicolor'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-colored',
    name: 'Rutabaga - Colored',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colored rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Colored'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-kohlrabi',
    name: 'Parsnip - Kohlrabi',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Kohlrabi parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Kohlrabi'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-cabbage-turnip',
    name: 'Celeriac - Cabbage Turnip',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Cabbage Turnip celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cabbage Turnip'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-german-turnip',
    name: 'Horseradish - German Turnip',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'German Turnip horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['German Turnip'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-stem-turnip',
    name: 'Salsify - Stem Turnip',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Stem Turnip salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Stem Turnip'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-brassica',
    name: 'Scorzonera - Brassica',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brassica scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Brassica'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-turnip',
    name: 'Taro - Turnip',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turnip taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Turnip'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-purple-top',
    name: 'Yuca - Purple Top',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Top yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Purple Top'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-white-globe',
    name: 'Jerusalem artichoke - White Globe',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Globe jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['White Globe'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-golden-ball',
    name: 'Daikon - Golden Ball',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden Ball daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Golden Ball'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-milan',
    name: 'Rutabaga - Milan',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Milan rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Milan'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-rutabaga',
    name: 'Parsnip - Rutabaga',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Rutabaga parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Rutabaga'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-swede',
    name: 'Celeriac - Swede',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Swede celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Swede'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-yellow-turnip',
    name: 'Horseradish - Yellow Turnip',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Turnip horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Yellow Turnip'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-swedish-turnip',
    name: 'Salsify - Swedish Turnip',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swedish Turnip salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Swedish Turnip'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-neep',
    name: 'Scorzonera - Neep',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Neep scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Neep'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-american-purple-top',
    name: 'Taro - American Purple Top',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'American Purple Top taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['American Purple Top'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-laurentian',
    name: 'Yuca - Laurentian',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Laurentian yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Laurentian'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-joan',
    name: 'Jerusalem artichoke - Joan',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Joan jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Joan'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-marian',
    name: 'Daikon - Marian',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Marian daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Marian'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-nadmorska',
    name: 'Rutabaga - Nadmorska',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nadmorska rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Nadmorska'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-hollow-crown-2',
    name: 'Parsnip - Hollow Crown 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Hollow Crown 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Hollow Crown 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-all-american-2',
    name: 'Celeriac - All American 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'All American 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['All American 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-javelin-2',
    name: 'Horseradish - Javelin 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Javelin 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Javelin 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-gladiator-2',
    name: 'Salsify - Gladiator 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gladiator 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Gladiator 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-lancer-2',
    name: 'Scorzonera - Lancer 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lancer 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lancer 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-turga-2',
    name: 'Taro - Turga 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turga 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Turga 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-andover-2',
    name: 'Yuca - Andover 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Andover 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Andover 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-albion-2',
    name: 'Jerusalem artichoke - Albion 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Albion 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Albion 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-dagger-2',
    name: 'Daikon - Dagger 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dagger 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Dagger 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-panache-2',
    name: 'Rutabaga - Panache 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panache 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Panache 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-brilliant-2',
    name: 'Parsnip - Brilliant 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Brilliant 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Brilliant 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-monarch-2',
    name: 'Celeriac - Monarch 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Monarch 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Monarch 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-prinz-2',
    name: 'Horseradish - Prinz 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prinz 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Prinz 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-snow-white-2',
    name: 'Salsify - Snow White 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Snow White 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Snow White 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-tellus-2',
    name: 'Scorzonera - Tellus 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tellus 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tellus 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-victoria-2',
    name: 'Taro - Victoria 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Victoria 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Victoria 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-giant-prague-2',
    name: 'Yuca - Giant Prague 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant Prague 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Giant Prague 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-diamant-2',
    name: 'Jerusalem artichoke - Diamant 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Diamant 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Diamant 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-ibis-2',
    name: 'Daikon - Ibis 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ibis 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ibis 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-maxim-2',
    name: 'Rutabaga - Maxim 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maxim 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Maxim 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-mars-2',
    name: 'Parsnip - Mars 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Mars 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Mars 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-novella-2',
    name: 'Celeriac - Novella 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Novella 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Novella 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-soprano-2',
    name: 'Horseradish - Soprano 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soprano 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Soprano 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-alabaster-2',
    name: 'Salsify - Alabaster 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alabaster 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Alabaster 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-asterix-2',
    name: 'Scorzonera - Asterix 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Asterix 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Asterix 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-bohemia-2',
    name: 'Taro - Bohemia 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bohemia 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Bohemia 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-celio-2',
    name: 'Yuca - Celio 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celio 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Celio 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-celeriac-2',
    name: 'Jerusalem artichoke - Celeriac 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celeriac 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Celeriac 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-celine-2',
    name: 'Daikon - Celine 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celine 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Celine 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-ceres-2',
    name: 'Rutabaga - Ceres 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ceres 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ceres 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-cesar-2',
    name: 'Parsnip - Cesar 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Cesar 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cesar 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-cobalt-2',
    name: 'Celeriac - Cobalt 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Cobalt 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cobalt 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-dolvi-2',
    name: 'Horseradish - Dolvi 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dolvi 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Dolvi 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-gildor-2',
    name: 'Salsify - Gildor 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gildor 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Gildor 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-iram-2',
    name: 'Scorzonera - Iram 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Iram 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Iram 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-kariba-2',
    name: 'Taro - Kariba 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kariba 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Kariba 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-kojak-2',
    name: 'Yuca - Kojak 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kojak 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Kojak 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-monarch-2',
    name: 'Jerusalem artichoke - Monarch 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monarch 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Monarch 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-prague-2',
    name: 'Daikon - Prague 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prague 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Prague 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-regent-2',
    name: 'Rutabaga - Regent 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Regent 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Regent 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-sedan-2',
    name: 'Parsnip - Sedan 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Sedan 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Sedan 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-tellus-2',
    name: 'Celeriac - Tellus 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Tellus 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Tellus 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-titus-2',
    name: 'Horseradish - Titus 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Titus 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Titus 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-velt-2',
    name: 'Salsify - Velt 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Velt 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Velt 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-victoria-2',
    name: 'Scorzonera - Victoria 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Victoria 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Victoria 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-malanga-2',
    name: 'Taro - Malanga 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Malanga 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Malanga 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-coco-yam-2',
    name: 'Yuca - Coco Yam 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Coco Yam 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Coco Yam 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-eddoe-2',
    name: 'Jerusalem artichoke - Eddoe 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eddoe 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Eddoe 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-dasheen-2',
    name: 'Daikon - Dasheen 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dasheen 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Dasheen 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-chinese-2',
    name: 'Rutabaga - Chinese 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Chinese 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-lehua-2',
    name: 'Parsnip - Lehua 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Lehua 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Lehua 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-bun-long-2',
    name: 'Celeriac - Bun Long 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Bun Long 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Bun Long 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-maui-lehua-2',
    name: 'Horseradish - Maui Lehua 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maui Lehua 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Maui Lehua 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-kalo-2',
    name: 'Salsify - Kalo 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kalo 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Kalo 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-tahitian-2',
    name: 'Scorzonera - Tahitian 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tahitian 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tahitian 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-white-2',
    name: 'Taro - White 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['White 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-yellow-2',
    name: 'Yuca - Yellow 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Yellow 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-sweet-2',
    name: 'Jerusalem artichoke - Sweet 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sweet 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-bitter-2',
    name: 'Daikon - Bitter 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Bitter 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-manioc-2',
    name: 'Rutabaga - Manioc 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Manioc 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Manioc 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-yuca-root-2',
    name: 'Parsnip - Yuca Root 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Yuca Root 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Yuca Root 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-cassava-2',
    name: 'Celeriac - Cassava 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Cassava 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cassava 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-tapioca-2',
    name: 'Horseradish - Tapioca 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tapioca 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Tapioca 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-brazilian-arrowroot-2',
    name: 'Salsify - Brazilian Arrowroot 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brazilian Arrowroot 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Brazilian Arrowroot 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-manioc-meal-2',
    name: 'Scorzonera - Manioc Meal 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Manioc Meal 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Manioc Meal 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-mashua-2',
    name: 'Taro - Mashua 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mashua 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Mashua 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-anu-2',
    name: 'Yuca - Anu 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Anu 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Anu 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-cubio-2',
    name: 'Jerusalem artichoke - Cubio 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cubio 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Cubio 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-tuberous-nasturtium-2',
    name: 'Daikon - Tuberous Nasturtium 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tuberous Nasturtium 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tuberous Nasturtium 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-tropaeolum-2',
    name: 'Rutabaga - Tropaeolum 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tropaeolum 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tropaeolum 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-oca-2',
    name: 'Parsnip - Oca 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Oca 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Oca 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-new-zealand-yam-2',
    name: 'Celeriac - New Zealand Yam 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'New Zealand Yam 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['New Zealand Yam 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-oxalis-2',
    name: 'Horseradish - Oxalis 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oxalis 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Oxalis 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-wood-sorrel-2',
    name: 'Salsify - Wood Sorrel 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wood Sorrel 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Wood Sorrel 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-uqa-2',
    name: 'Scorzonera - Uqa 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Uqa 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Uqa 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-ulluco-2',
    name: 'Taro - Ulluco 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ulluco 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Ulluco 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-papa-lisa-2',
    name: 'Yuca - Papa Lisa 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Papa Lisa 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Papa Lisa 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-melloco-2',
    name: 'Jerusalem artichoke - Melloco 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Melloco 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Melloco 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-ruba-2',
    name: 'Daikon - Ruba 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruba 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ruba 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-chugua-2',
    name: 'Rutabaga - Chugua 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chugua 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Chugua 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-yacon-2',
    name: 'Parsnip - Yacon 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Yacon 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Yacon 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-apple-of-the-earth-2',
    name: 'Celeriac - Apple of the Earth 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Apple of the Earth 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Apple of the Earth 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-bolivian-sunroot-2',
    name: 'Horseradish - Bolivian Sunroot 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bolivian Sunroot 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Bolivian Sunroot 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-smallanthus-2',
    name: 'Salsify - Smallanthus 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smallanthus 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Smallanthus 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-sunroot-2',
    name: 'Scorzonera - Sunroot 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sunroot 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sunroot 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-maca-2',
    name: 'Taro - Maca 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maca 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Maca 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-peruvian-ginseng-2',
    name: 'Yuca - Peruvian Ginseng 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peruvian Ginseng 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Peruvian Ginseng 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-lepidium-2',
    name: 'Jerusalem artichoke - Lepidium 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lepidium 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lepidium 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-maka-2',
    name: 'Daikon - Maka 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maka 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Maka 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-andean-2',
    name: 'Rutabaga - Andean 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Andean 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Andean 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-chinese-artichoke-2',
    name: 'Parsnip - Chinese Artichoke 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Chinese Artichoke 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Chinese Artichoke 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-crosne-2',
    name: 'Celeriac - Crosne 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Crosne 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Crosne 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-japanese-artichoke-2',
    name: 'Horseradish - Japanese Artichoke 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese Artichoke 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Japanese Artichoke 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-knotroot-2',
    name: 'Salsify - Knotroot 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Knotroot 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Knotroot 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-artichoke-betony-2',
    name: 'Scorzonera - Artichoke Betony 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Artichoke Betony 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Artichoke Betony 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-salsify-2',
    name: 'Taro - Salsify 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Salsify 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Salsify 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-oyster-plant-2',
    name: 'Yuca - Oyster Plant 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oyster Plant 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Oyster Plant 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-vegetable-oyster-2',
    name: 'Jerusalem artichoke - Vegetable Oyster 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vegetable Oyster 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Vegetable Oyster 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-goatsbeard-2',
    name: 'Daikon - Goatsbeard 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'grain',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Goatsbeard 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Goatsbeard 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-tragopogon-2',
    name: 'Rutabaga - Tragopogon 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tragopogon 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tragopogon 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-scorzonera-2',
    name: 'Parsnip - Scorzonera 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Scorzonera 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Scorzonera 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-black-salsify-2',
    name: 'Celeriac - Black Salsify 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Black Salsify 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Black Salsify 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-viper-grass-2',
    name: 'Horseradish - Viper Grass 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Viper Grass 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Viper Grass 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-spanish-salsify-2',
    name: 'Salsify - Spanish Salsify 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Salsify 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Spanish Salsify 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-scorzonera-hispanica-2',
    name: 'Scorzonera - Scorzonera Hispanica 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Scorzonera Hispanica 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Scorzonera Hispanica 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-skirret-2',
    name: 'Taro - Skirret 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Skirret 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Skirret 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-water-parsnip-2',
    name: 'Yuca - Water Parsnip 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Water Parsnip 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Water Parsnip 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-sium-2',
    name: 'Jerusalem artichoke - Sium 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sium 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sium 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-crummock-2',
    name: 'Daikon - Crummock 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crummock 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Crummock 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-sium-sisarum-2',
    name: 'Rutabaga - Sium Sisarum 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sium Sisarum 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sium Sisarum 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-hamburg-parsley-2',
    name: 'Parsnip - Hamburg Parsley 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Hamburg Parsley 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Hamburg Parsley 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-turnip-rooted-2',
    name: 'Celeriac - Turnip Rooted 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Turnip Rooted 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Turnip Rooted 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-parsnip-rooted-2',
    name: 'Horseradish - Parsnip Rooted 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Parsnip Rooted 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Parsnip Rooted 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-hamburg-2',
    name: 'Salsify - Hamburg 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hamburg 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Hamburg 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-root-parsley-2',
    name: 'Scorzonera - Root Parsley 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Root Parsley 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Root Parsley 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-arracacha-2',
    name: 'Taro - Arracacha 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arracacha 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Arracacha 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-white-carrot-2',
    name: 'Yuca - White Carrot 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Carrot 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['White Carrot 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-peruvian-parsnip-2',
    name: 'Jerusalem artichoke - Peruvian Parsnip 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peruvian Parsnip 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Peruvian Parsnip 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-apio-2',
    name: 'Daikon - Apio 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apio 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Apio 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-arracacia-2',
    name: 'Rutabaga - Arracacia 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arracacia 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Arracacia 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-pignut-2',
    name: 'Parsnip - Pignut 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Pignut 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Pignut 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-earth-nut-2',
    name: 'Celeriac - Earth Nut 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Earth Nut 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Earth Nut 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-conopodium-2',
    name: 'Horseradish - Conopodium 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Conopodium 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Conopodium 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-kippernut-2',
    name: 'Salsify - Kippernut 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kippernut 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Kippernut 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-hognut-2',
    name: 'Scorzonera - Hognut 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hognut 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Hognut 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-chufa-2',
    name: 'Taro - Chufa 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chufa 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Chufa 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-tiger-nut-2',
    name: 'Yuca - Tiger Nut 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tiger Nut 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Tiger Nut 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-yellow-nut-sedge-2',
    name: 'Jerusalem artichoke - Yellow Nut Sedge 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Nut Sedge 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Yellow Nut Sedge 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-cyperus-2',
    name: 'Daikon - Cyperus 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cyperus 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Cyperus 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-zulu-nut-2',
    name: 'Rutabaga - Zulu Nut 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zulu Nut 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Zulu Nut 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-lotus-root-2',
    name: 'Parsnip - Lotus Root 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Lotus Root 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Lotus Root 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-renkon-2',
    name: 'Celeriac - Renkon 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Renkon 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Renkon 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-nelumbo-2',
    name: 'Horseradish - Nelumbo 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nelumbo 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Nelumbo 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-sacred-lotus-2',
    name: 'Salsify - Sacred Lotus 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sacred Lotus 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sacred Lotus 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-hasu-2',
    name: 'Scorzonera - Hasu 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hasu 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Hasu 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-wasabi-2',
    name: 'Taro - Wasabi 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wasabi 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Wasabi 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-japanese-horseradish-2',
    name: 'Yuca - Japanese Horseradish 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese Horseradish 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Japanese Horseradish 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-eutrema-2',
    name: 'Jerusalem artichoke - Eutrema 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eutrema 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Eutrema 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-wasabia-2',
    name: 'Daikon - Wasabia 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wasabia 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Wasabia 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-kona-2',
    name: 'Rutabaga - Kona 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kona 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Kona 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-horseradish-2',
    name: 'Parsnip - Horseradish 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Horseradish 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Horseradish 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-red-cole-2',
    name: 'Celeriac - Red Cole 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Red Cole 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Red Cole 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-armoracia-2',
    name: 'Horseradish - Armoracia 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Armoracia 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Armoracia 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-horse-radish-2',
    name: 'Salsify - Horse Radish 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Horse Radish 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Horse Radish 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-cren-2',
    name: 'Scorzonera - Cren 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cren 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Cren 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-daikon-2',
    name: 'Taro - Daikon 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Daikon 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-white-radish-2',
    name: 'Yuca - White Radish 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Radish 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['White Radish 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-japanese-radish-2',
    name: 'Jerusalem artichoke - Japanese Radish 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese Radish 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Japanese Radish 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-oriental-radish-2',
    name: 'Daikon - Oriental Radish 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oriental Radish 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Oriental Radish 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-mooli-2',
    name: 'Rutabaga - Mooli 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mooli 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Mooli 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-watermelon-radish-2',
    name: 'Parsnip - Watermelon Radish 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Watermelon Radish 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Watermelon Radish 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-red-meat-2',
    name: 'Celeriac - Red Meat 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Red Meat 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Red Meat 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-beauty-heart-2',
    name: 'Horseradish - Beauty Heart 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Beauty Heart 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Beauty Heart 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-shinrimei-2',
    name: 'Salsify - Shinrimei 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Shinrimei 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Shinrimei 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-xin-li-mei-2',
    name: 'Scorzonera - Xin Li Mei 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Xin Li Mei 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Xin Li Mei 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-black-radish-2',
    name: 'Taro - Black Radish 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Black Radish 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Black Radish 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-spanish-radish-2',
    name: 'Yuca - Spanish Radish 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Radish 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Spanish Radish 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-gros-noir-2',
    name: 'Jerusalem artichoke - Gros Noir 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gros Noir 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Gros Noir 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-noir-gros-2',
    name: 'Daikon - Noir Gros 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Noir Gros 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Noir Gros 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-raphanus-2',
    name: 'Rutabaga - Raphanus 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Raphanus 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Raphanus 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-icicle-radish-2',
    name: 'Parsnip - Icicle Radish 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Icicle Radish 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Icicle Radish 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-white-icicle-2',
    name: 'Celeriac - White Icicle 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'White Icicle 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['White Icicle 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-long-white-2',
    name: 'Horseradish - Long White 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Long White 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Long White 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-lady-finger-2',
    name: 'Salsify - Lady Finger 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lady Finger 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lady Finger 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-daikon-type-2',
    name: 'Scorzonera - Daikon Type 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Daikon Type 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Daikon Type 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-easter-egg-2',
    name: 'Taro - Easter Egg 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Easter Egg 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Easter Egg 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-rainbow-2',
    name: 'Yuca - Rainbow 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Rainbow 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Rainbow 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-easter-egg-ii-2',
    name: 'Jerusalem artichoke - Easter Egg II 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Easter Egg II 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Easter Egg II 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-multicolor-2',
    name: 'Daikon - Multicolor 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Multicolor 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Multicolor 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-colored-2',
    name: 'Rutabaga - Colored 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Colored 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Colored 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-kohlrabi-2',
    name: 'Parsnip - Kohlrabi 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Kohlrabi 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Kohlrabi 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-cabbage-turnip-2',
    name: 'Celeriac - Cabbage Turnip 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Cabbage Turnip 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cabbage Turnip 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-german-turnip-2',
    name: 'Horseradish - German Turnip 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'German Turnip 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['German Turnip 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-stem-turnip-2',
    name: 'Salsify - Stem Turnip 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Stem Turnip 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Stem Turnip 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-brassica-2',
    name: 'Scorzonera - Brassica 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brassica 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Brassica 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-turnip-2',
    name: 'Taro - Turnip 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turnip 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Turnip 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-purple-top-2',
    name: 'Yuca - Purple Top 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Top 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Purple Top 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-white-globe-2',
    name: 'Jerusalem artichoke - White Globe 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Globe 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['White Globe 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-golden-ball-2',
    name: 'Daikon - Golden Ball 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Golden Ball 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Golden Ball 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-milan-2',
    name: 'Rutabaga - Milan 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Milan 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Milan 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-rutabaga-2',
    name: 'Parsnip - Rutabaga 2',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Rutabaga 2 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Rutabaga 2'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-swede-2',
    name: 'Celeriac - Swede 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Swede 2 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Swede 2'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-yellow-turnip-2',
    name: 'Horseradish - Yellow Turnip 2',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow Turnip 2 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Yellow Turnip 2'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-swedish-turnip-2',
    name: 'Salsify - Swedish Turnip 2',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Swedish Turnip 2 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Swedish Turnip 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-neep-2',
    name: 'Scorzonera - Neep 2',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Neep 2 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Neep 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-american-purple-top-2',
    name: 'Taro - American Purple Top 2',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'American Purple Top 2 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['American Purple Top 2'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-laurentian-2',
    name: 'Yuca - Laurentian 2',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Laurentian 2 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Laurentian 2'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-joan-2',
    name: 'Jerusalem artichoke - Joan 2',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Joan 2 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Joan 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-marian-2',
    name: 'Daikon - Marian 2',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Marian 2 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Marian 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-nadmorska-2',
    name: 'Rutabaga - Nadmorska 2',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Nadmorska 2 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Nadmorska 2'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-hollow-crown-3',
    name: 'Parsnip - Hollow Crown 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Hollow Crown 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Hollow Crown 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-all-american-3',
    name: 'Celeriac - All American 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'All American 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['All American 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-javelin-3',
    name: 'Horseradish - Javelin 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Javelin 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Javelin 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-gladiator-3',
    name: 'Salsify - Gladiator 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gladiator 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Gladiator 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-lancer-3',
    name: 'Scorzonera - Lancer 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lancer 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lancer 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-turga-3',
    name: 'Taro - Turga 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Turga 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Turga 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-andover-3',
    name: 'Yuca - Andover 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Andover 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Andover 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-albion-3',
    name: 'Jerusalem artichoke - Albion 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Albion 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Albion 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-dagger-3',
    name: 'Daikon - Dagger 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dagger 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Dagger 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-panache-3',
    name: 'Rutabaga - Panache 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Panache 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Panache 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-brilliant-3',
    name: 'Parsnip - Brilliant 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Brilliant 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Brilliant 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-monarch-3',
    name: 'Celeriac - Monarch 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Monarch 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Monarch 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-prinz-3',
    name: 'Horseradish - Prinz 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prinz 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Prinz 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-snow-white-3',
    name: 'Salsify - Snow White 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Snow White 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Snow White 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-tellus-3',
    name: 'Scorzonera - Tellus 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tellus 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tellus 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-victoria-3',
    name: 'Taro - Victoria 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Victoria 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Victoria 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-giant-prague-3',
    name: 'Yuca - Giant Prague 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant Prague 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Giant Prague 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-diamant-3',
    name: 'Jerusalem artichoke - Diamant 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Diamant 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Diamant 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-ibis-3',
    name: 'Daikon - Ibis 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ibis 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ibis 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-maxim-3',
    name: 'Rutabaga - Maxim 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maxim 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Maxim 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-mars-3',
    name: 'Parsnip - Mars 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Mars 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Mars 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-novella-3',
    name: 'Celeriac - Novella 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Novella 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Novella 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-soprano-3',
    name: 'Horseradish - Soprano 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Soprano 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Soprano 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-alabaster-3',
    name: 'Salsify - Alabaster 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alabaster 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Alabaster 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-asterix-3',
    name: 'Scorzonera - Asterix 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Asterix 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Asterix 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-bohemia-3',
    name: 'Taro - Bohemia 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bohemia 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Bohemia 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-celio-3',
    name: 'Yuca - Celio 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celio 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Celio 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-celeriac-3',
    name: 'Jerusalem artichoke - Celeriac 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celeriac 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Celeriac 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-celine-3',
    name: 'Daikon - Celine 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Celine 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Celine 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-ceres-3',
    name: 'Rutabaga - Ceres 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ceres 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ceres 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-cesar-3',
    name: 'Parsnip - Cesar 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Cesar 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cesar 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-cobalt-3',
    name: 'Celeriac - Cobalt 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Cobalt 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cobalt 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-dolvi-3',
    name: 'Horseradish - Dolvi 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dolvi 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Dolvi 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-gildor-3',
    name: 'Salsify - Gildor 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gildor 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Gildor 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-iram-3',
    name: 'Scorzonera - Iram 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Iram 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Iram 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-kariba-3',
    name: 'Taro - Kariba 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kariba 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Kariba 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-kojak-3',
    name: 'Yuca - Kojak 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kojak 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Kojak 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-monarch-3',
    name: 'Jerusalem artichoke - Monarch 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monarch 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Monarch 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-prague-3',
    name: 'Daikon - Prague 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prague 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Prague 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-regent-3',
    name: 'Rutabaga - Regent 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Regent 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Regent 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-sedan-3',
    name: 'Parsnip - Sedan 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Sedan 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Sedan 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-tellus-3',
    name: 'Celeriac - Tellus 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Tellus 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Tellus 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-titus-3',
    name: 'Horseradish - Titus 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Titus 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Titus 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-velt-3',
    name: 'Salsify - Velt 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Velt 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Velt 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-victoria-3',
    name: 'Scorzonera - Victoria 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Victoria 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Victoria 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-malanga-3',
    name: 'Taro - Malanga 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Malanga 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Malanga 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-coco-yam-3',
    name: 'Yuca - Coco Yam 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Coco Yam 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Coco Yam 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-eddoe-3',
    name: 'Jerusalem artichoke - Eddoe 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Eddoe 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Eddoe 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-dasheen-3',
    name: 'Daikon - Dasheen 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dasheen 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Dasheen 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-chinese-3',
    name: 'Rutabaga - Chinese 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chinese 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Chinese 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-lehua-3',
    name: 'Parsnip - Lehua 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Lehua 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Lehua 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-bun-long-3',
    name: 'Celeriac - Bun Long 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Bun Long 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Bun Long 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-maui-lehua-3',
    name: 'Horseradish - Maui Lehua 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maui Lehua 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Maui Lehua 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-kalo-3',
    name: 'Salsify - Kalo 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kalo 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Kalo 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-tahitian-3',
    name: 'Scorzonera - Tahitian 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tahitian 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tahitian 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-white-3',
    name: 'Taro - White 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['White 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-yellow-3',
    name: 'Yuca - Yellow 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Yellow 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-sweet-3',
    name: 'Jerusalem artichoke - Sweet 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sweet 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-bitter-3',
    name: 'Daikon - Bitter 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Bitter 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-manioc-3',
    name: 'Rutabaga - Manioc 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Manioc 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Manioc 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-yuca-root-3',
    name: 'Parsnip - Yuca Root 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Yuca Root 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Yuca Root 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-cassava-3',
    name: 'Celeriac - Cassava 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Cassava 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Cassava 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-tapioca-3',
    name: 'Horseradish - Tapioca 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tapioca 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Tapioca 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-brazilian-arrowroot-3',
    name: 'Salsify - Brazilian Arrowroot 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brazilian Arrowroot 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Brazilian Arrowroot 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-manioc-meal-3',
    name: 'Scorzonera - Manioc Meal 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Manioc Meal 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Manioc Meal 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-mashua-3',
    name: 'Taro - Mashua 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mashua 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Mashua 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-anu-3',
    name: 'Yuca - Anu 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Anu 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Anu 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-cubio-3',
    name: 'Jerusalem artichoke - Cubio 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cubio 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Cubio 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-tuberous-nasturtium-3',
    name: 'Daikon - Tuberous Nasturtium 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tuberous Nasturtium 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tuberous Nasturtium 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-tropaeolum-3',
    name: 'Rutabaga - Tropaeolum 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tropaeolum 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tropaeolum 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-oca-3',
    name: 'Parsnip - Oca 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Oca 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Oca 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-new-zealand-yam-3',
    name: 'Celeriac - New Zealand Yam 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'New Zealand Yam 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['New Zealand Yam 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-oxalis-3',
    name: 'Horseradish - Oxalis 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oxalis 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Oxalis 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-wood-sorrel-3',
    name: 'Salsify - Wood Sorrel 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wood Sorrel 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Wood Sorrel 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-uqa-3',
    name: 'Scorzonera - Uqa 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Uqa 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Uqa 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-ulluco-3',
    name: 'Taro - Ulluco 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ulluco 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Ulluco 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-papa-lisa-3',
    name: 'Yuca - Papa Lisa 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Papa Lisa 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Papa Lisa 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-melloco-3',
    name: 'Jerusalem artichoke - Melloco 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Melloco 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Melloco 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-ruba-3',
    name: 'Daikon - Ruba 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Ruba 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Ruba 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-chugua-3',
    name: 'Rutabaga - Chugua 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Chugua 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Chugua 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-yacon-3',
    name: 'Parsnip - Yacon 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Yacon 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Yacon 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-apple-of-the-earth-3',
    name: 'Celeriac - Apple of the Earth 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Apple of the Earth 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Apple of the Earth 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-bolivian-sunroot-3',
    name: 'Horseradish - Bolivian Sunroot 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bolivian Sunroot 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Bolivian Sunroot 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-smallanthus-3',
    name: 'Salsify - Smallanthus 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smallanthus 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Smallanthus 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-sunroot-3',
    name: 'Scorzonera - Sunroot 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sunroot 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sunroot 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-maca-3',
    name: 'Taro - Maca 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maca 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Maca 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-peruvian-ginseng-3',
    name: 'Yuca - Peruvian Ginseng 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peruvian Ginseng 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Peruvian Ginseng 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-lepidium-3',
    name: 'Jerusalem artichoke - Lepidium 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Lepidium 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Lepidium 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-maka-3',
    name: 'Daikon - Maka 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Maka 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Maka 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-andean-3',
    name: 'Rutabaga - Andean 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Andean 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Andean 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-chinese-artichoke-3',
    name: 'Parsnip - Chinese Artichoke 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Chinese Artichoke 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Chinese Artichoke 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-crosne-3',
    name: 'Celeriac - Crosne 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Crosne 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Crosne 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-japanese-artichoke-3',
    name: 'Horseradish - Japanese Artichoke 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Japanese Artichoke 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Japanese Artichoke 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-knotroot-3',
    name: 'Salsify - Knotroot 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Knotroot 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Knotroot 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-artichoke-betony-3',
    name: 'Scorzonera - Artichoke Betony 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Artichoke Betony 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Artichoke Betony 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-salsify-3',
    name: 'Taro - Salsify 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Salsify 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Salsify 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-oyster-plant-3',
    name: 'Yuca - Oyster Plant 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Oyster Plant 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Oyster Plant 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-vegetable-oyster-3',
    name: 'Jerusalem artichoke - Vegetable Oyster 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vegetable Oyster 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Vegetable Oyster 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-goatsbeard-3',
    name: 'Daikon - Goatsbeard 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'grain',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Goatsbeard 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Goatsbeard 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-tragopogon-3',
    name: 'Rutabaga - Tragopogon 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tragopogon 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Tragopogon 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-scorzonera-3',
    name: 'Parsnip - Scorzonera 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Scorzonera 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Scorzonera 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-black-salsify-3',
    name: 'Celeriac - Black Salsify 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Black Salsify 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Black Salsify 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-viper-grass-3',
    name: 'Horseradish - Viper Grass 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Viper Grass 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Viper Grass 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-spanish-salsify-3',
    name: 'Salsify - Spanish Salsify 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish Salsify 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Spanish Salsify 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-scorzonera-hispanica-3',
    name: 'Scorzonera - Scorzonera Hispanica 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Scorzonera Hispanica 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Scorzonera Hispanica 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-skirret-3',
    name: 'Taro - Skirret 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Skirret 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Skirret 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-water-parsnip-3',
    name: 'Yuca - Water Parsnip 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Water Parsnip 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['Water Parsnip 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-sium-3',
    name: 'Jerusalem artichoke - Sium 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sium 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sium 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-crummock-3',
    name: 'Daikon - Crummock 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Crummock 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Crummock 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-sium-sisarum-3',
    name: 'Rutabaga - Sium Sisarum 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sium Sisarum 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Sium Sisarum 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'parsnip-hamburg-parsley-3',
    name: 'Parsnip - Hamburg Parsley 3',
    scientificName: 'Pastinaca sativa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 21,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: [],
    description: 'Hamburg Parsley 3 parsnip. Sweet, nutty root, better after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Hamburg Parsley 3'],
    uses: ['roasting', 'soup', 'mashing']
  },
  {
    id: 'celeriac-turnip-rooted-3',
    name: 'Celeriac - Turnip Rooted 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 14,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Turnip Rooted 3 celeriac. Knobby root with celery flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Apiaceae',
    varieties: ['Turnip Rooted 3'],
    uses: ['remoulade', 'soup', 'mashing']
  },
  {
    id: 'horseradish-parsnip-rooted-3',
    name: 'Horseradish - Parsnip Rooted 3',
    scientificName: 'Armoracia rusticana',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 120,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Parsnip Rooted 3 horseradish. Pungent perennial root for sauce.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: 'indefinite',
    family: 'Asteraceae',
    varieties: ['Parsnip Rooted 3'],
    uses: ['sauce', 'condiment']
  },
  {
    id: 'salsify-hamburg-3',
    name: 'Salsify - Hamburg 3',
    scientificName: 'Tragopogon porrifolius',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hamburg 3 salsify. Oyster-flavored root, purple flower.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Hamburg 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'scorzonera-root-parsley-3',
    name: 'Scorzonera - Root Parsley 3',
    scientificName: 'Scorzonera hispanica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Root Parsley 3 scorzonera. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Root Parsley 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'taro-arracacha-3',
    name: 'Taro - Arracacha 3',
    scientificName: 'Colocasia esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arracacha 3 taro. Starchy tropical tuber, poi in Hawaii.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2-3 feet',
    family: 'Araceae',
    varieties: ['Arracacha 3'],
    uses: ['poi', 'chips', 'cooking']
  },
  {
    id: 'yuca-white-carrot-3',
    name: 'Yuca - White Carrot 3',
    scientificName: 'Manihot esculenta',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 270,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White Carrot 3 yuca. Tropical starch source, must be cooked.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '6-10 feet',
    spread: '3-4 feet',
    family: 'Euphorbiaceae',
    varieties: ['White Carrot 3'],
    uses: ['flour', 'fries', 'cooking']
  },
  {
    id: 'jerusalem-artichoke-peruvian-parsnip-3',
    name: 'Jerusalem artichoke - Peruvian Parsnip 3',
    scientificName: 'Helianthus tuberosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 30,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Peruvian Parsnip 3 jerusalem artichoke. Sunchoke, nutty tuber, perennial.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Peruvian Parsnip 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'daikon-apio-3',
    name: 'Daikon - Apio 3',
    scientificName: 'Raphanus sativus var. longipinnatus',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apio 3 daikon. Mild Asian radish, large white root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Apio 3'],
    uses: ['roasting', 'soup', 'stew']
  },
  {
    id: 'rutabaga-arracacia-3',
    name: 'Rutabaga - Arracacia 3',
    scientificName: 'Brassica napus var. napobrassica',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Arracacia 3 rutabaga. Sweet rutabaga, excellent storage.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '12-18 inches',
    family: 'Asteraceae',
    varieties: ['Arracacia 3'],
    uses: ['roasting', 'soup', 'stew']
  }
,
  {
    id: 'lentil-green',
    name: 'Lentil - Green',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-red',
    name: 'Chickpea - Red',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-french-green',
    name: 'Fava bean - French Green',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French Green fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French Green'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-beluga',
    name: 'Soybean - Beluga',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Beluga soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Beluga'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-black',
    name: 'Edamame - Black',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-pardina',
    name: 'Cowpea - Pardina',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pardina cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Pardina'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-masoor',
    name: 'Mung bean - Masoor',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Masoor mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Masoor'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-urad',
    name: 'Adzuki bean - Urad',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Urad adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Urad'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-toor',
    name: 'Lentil - Toor',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Toor lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Toor'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-chana-dal',
    name: 'Chickpea - Chana Dal',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chana Dal chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chana Dal'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-kabuli',
    name: 'Fava bean - Kabuli',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Kabuli fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Kabuli'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-desi',
    name: 'Soybean - Desi',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Desi soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Desi'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-garbanzo',
    name: 'Edamame - Garbanzo',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Garbanzo edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Garbanzo'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-ceci',
    name: 'Cowpea - Ceci',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Ceci cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Ceci'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-egyptian',
    name: 'Mung bean - Egyptian',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Egyptian mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Egyptian'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-broad-windsor',
    name: 'Adzuki bean - Broad Windsor',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Broad Windsor adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Broad Windsor'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-aquadulce',
    name: 'Lentil - Aquadulce',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Aquadulce lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Aquadulce'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-sweet',
    name: 'Chickpea - Sweet',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sweet chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sweet'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-horse-bean',
    name: 'Fava bean - Horse Bean',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Horse Bean fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Horse Bean'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-tick',
    name: 'Soybean - Tick',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Tick soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Tick'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-edamame',
    name: 'Edamame - Edamame',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Edamame edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Edamame'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-green-shell',
    name: 'Cowpea - Green Shell',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Shell cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Green Shell'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-butterbean',
    name: 'Mung bean - Butterbean',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Butterbean mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Butterbean'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-envy',
    name: 'Adzuki bean - Envy',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Envy adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Envy'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-besweet',
    name: 'Lentil - BeSweet',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'BeSweet lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['BeSweet'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-black-jet',
    name: 'Chickpea - Black Jet',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black Jet chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black Jet'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-midori-giant',
    name: 'Fava bean - Midori Giant',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Midori Giant fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Midori Giant'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-lucky-lion',
    name: 'Soybean - Lucky Lion',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Lucky Lion soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Lucky Lion'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-sayamusume',
    name: 'Edamame - Sayamusume',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sayamusume edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sayamusume'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-shirofumi',
    name: 'Cowpea - Shirofumi',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Shirofumi cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Shirofumi'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-california-blackeye',
    name: 'Mung bean - California Blackeye',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'California Blackeye mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['California Blackeye'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-purple-hull',
    name: 'Adzuki bean - Purple Hull',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Purple Hull adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Purple Hull'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-crowder',
    name: 'Lentil - Crowder',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Crowder lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Crowder'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-pinkeye',
    name: 'Chickpea - Pinkeye',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pinkeye chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pinkeye'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-mississippi-silver',
    name: 'Fava bean - Mississippi Silver',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mississippi Silver fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mississippi Silver'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-red-ripper',
    name: 'Soybean - Red Ripper',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Ripper soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Ripper'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-texas-cream',
    name: 'Edamame - Texas Cream',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Texas Cream edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Texas Cream'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-elite',
    name: 'Cowpea - Elite',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Elite cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Elite'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-iron-clay',
    name: 'Mung bean - Iron Clay',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Iron Clay mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Iron Clay'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-knuckle',
    name: 'Adzuki bean - Knuckle',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Knuckle adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Knuckle'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-golden',
    name: 'Lentil - Golden',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Golden lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Golden'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-green',
    name: 'Chickpea - Green',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-black',
    name: 'Fava bean - Black',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-red',
    name: 'Soybean - Red',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-yellow',
    name: 'Edamame - Yellow',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Yellow edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Yellow'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-chinese-red',
    name: 'Cowpea - Chinese Red',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese Red cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Chinese Red'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-field-pea',
    name: 'Mung bean - Field Pea',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Field Pea mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Field Pea'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-southern',
    name: 'Adzuki bean - Southern',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Southern adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Southern'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-clay',
    name: 'Lentil - Clay',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Clay lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Clay'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-speckled',
    name: 'Chickpea - Speckled',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Speckled chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Speckled'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-small-red',
    name: 'Fava bean - Small Red',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Small Red fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Small Red'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-large-red',
    name: 'Soybean - Large Red',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Large Red soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Large Red'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-red-chief',
    name: 'Edamame - Red Chief',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Chief edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Chief'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-takara',
    name: 'Cowpea - Takara',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Takara cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Takara'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-erimo',
    name: 'Mung bean - Erimo',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Erimo mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Erimo'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-green',
    name: 'Adzuki bean - Green',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-red',
    name: 'Lentil - Red',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-black',
    name: 'Chickpea - Black',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-white',
    name: 'Fava bean - White',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'White fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['White'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-brown',
    name: 'Soybean - Brown',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Brown soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Brown'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-french',
    name: 'Edamame - French',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-spanish',
    name: 'Cowpea - Spanish',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Spanish cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Spanish'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-italian',
    name: 'Mung bean - Italian',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Italian mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Italian'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-greek',
    name: 'Adzuki bean - Greek',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Greek adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Greek'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-turkish',
    name: 'Lentil - Turkish',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Turkish lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Turkish'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-indian',
    name: 'Chickpea - Indian',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Indian chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Indian'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-chinese',
    name: 'Fava bean - Chinese',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-japanese',
    name: 'Soybean - Japanese',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Japanese soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Japanese'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-korean',
    name: 'Edamame - Korean',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Korean edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Korean'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-thai',
    name: 'Cowpea - Thai',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Thai cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Thai'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-organic',
    name: 'Mung bean - Organic',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Organic mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Organic'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-heirloom',
    name: 'Adzuki bean - Heirloom',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heirloom'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-hybrid',
    name: 'Lentil - Hybrid',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Hybrid lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Hybrid'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-gmo',
    name: 'Chickpea - GMO',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'GMO chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['GMO'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-non-gmo',
    name: 'Fava bean - Non-GMO',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Non-GMO fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Non-GMO'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-dwarf',
    name: 'Soybean - Dwarf',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Dwarf soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Dwarf'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-bush',
    name: 'Edamame - Bush',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Bush edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Bush'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-pole',
    name: 'Cowpea - Pole',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pole cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Pole'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-climbing',
    name: 'Mung bean - Climbing',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Climbing mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Climbing'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-vining',
    name: 'Adzuki bean - Vining',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vining adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vining'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-early',
    name: 'Lentil - Early',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Early lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Early'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-mid',
    name: 'Chickpea - Mid',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mid chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mid'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-late',
    name: 'Fava bean - Late',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Late fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Late'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-main-season',
    name: 'Soybean - Main Season',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Main Season soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Main Season'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-all-season',
    name: 'Edamame - All Season',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'All Season edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['All Season'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-drought-tolerant',
    name: 'Cowpea - Drought Tolerant',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Drought Tolerant cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Drought Tolerant'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-heat-resistant',
    name: 'Mung bean - Heat Resistant',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heat Resistant mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heat Resistant'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-cold-hardy',
    name: 'Adzuki bean - Cold Hardy',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Cold Hardy adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Cold Hardy'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-disease-resistant',
    name: 'Lentil - Disease Resistant',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Disease Resistant lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Disease Resistant'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-high-yield',
    name: 'Chickpea - High Yield',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'High Yield chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['High Yield'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-protein-rich',
    name: 'Fava bean - Protein Rich',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Protein Rich fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Protein Rich'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-fiber-rich',
    name: 'Soybean - Fiber Rich',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Fiber Rich soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Fiber Rich'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-low-fat',
    name: 'Edamame - Low Fat',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Low Fat edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Low Fat'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-gluten-free',
    name: 'Cowpea - Gluten Free',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Gluten Free cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Gluten Free'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-vegan',
    name: 'Mung bean - Vegan',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vegan mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vegan'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-sprouting',
    name: 'Adzuki bean - Sprouting',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sprouting adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sprouting'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-drying',
    name: 'Lentil - Drying',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Drying lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Drying'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-canning',
    name: 'Chickpea - Canning',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Canning chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Canning'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-freezing',
    name: 'Fava bean - Freezing',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Freezing fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Freezing'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-fresh',
    name: 'Soybean - Fresh',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Fresh soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Fresh'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-cover-crop',
    name: 'Edamame - Cover Crop',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Cover Crop edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Cover Crop'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-nitrogen-fixer',
    name: 'Cowpea - Nitrogen Fixer',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Nitrogen Fixer cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Nitrogen Fixer'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-green-manure',
    name: 'Mung bean - Green Manure',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Manure mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green Manure'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-forage',
    name: 'Adzuki bean - Forage',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Forage adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Forage'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-silage',
    name: 'Lentil - Silage',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Silage lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Silage'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-green-2',
    name: 'Chickpea - Green 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-red-2',
    name: 'Fava bean - Red 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-french-green-2',
    name: 'Soybean - French Green 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French Green 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French Green 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-beluga-2',
    name: 'Edamame - Beluga 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Beluga 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Beluga 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-black-2',
    name: 'Cowpea - Black 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Black 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-pardina-2',
    name: 'Mung bean - Pardina 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pardina 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pardina 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-masoor-2',
    name: 'Adzuki bean - Masoor 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Masoor 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Masoor 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-urad-2',
    name: 'Lentil - Urad 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Urad 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Urad 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-toor-2',
    name: 'Chickpea - Toor 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Toor 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Toor 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-chana-dal-2',
    name: 'Fava bean - Chana Dal 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chana Dal 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chana Dal 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-kabuli-2',
    name: 'Soybean - Kabuli 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Kabuli 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Kabuli 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-desi-2',
    name: 'Edamame - Desi 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Desi 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Desi 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-garbanzo-2',
    name: 'Cowpea - Garbanzo 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Garbanzo 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Garbanzo 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-ceci-2',
    name: 'Mung bean - Ceci 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Ceci 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Ceci 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-egyptian-2',
    name: 'Adzuki bean - Egyptian 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Egyptian 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Egyptian 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-broad-windsor-2',
    name: 'Lentil - Broad Windsor 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Broad Windsor 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Broad Windsor 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-aquadulce-2',
    name: 'Chickpea - Aquadulce 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Aquadulce 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Aquadulce 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-sweet-2',
    name: 'Fava bean - Sweet 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sweet 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sweet 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-horse-bean-2',
    name: 'Soybean - Horse Bean 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Horse Bean 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Horse Bean 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-tick-2',
    name: 'Edamame - Tick 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Tick 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Tick 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-edamame-2',
    name: 'Cowpea - Edamame 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Edamame 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Edamame 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-green-shell-2',
    name: 'Mung bean - Green Shell 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Shell 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green Shell 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-butterbean-2',
    name: 'Adzuki bean - Butterbean 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Butterbean 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Butterbean 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-envy-2',
    name: 'Lentil - Envy 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Envy 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Envy 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-besweet-2',
    name: 'Chickpea - BeSweet 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'BeSweet 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['BeSweet 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-black-jet-2',
    name: 'Fava bean - Black Jet 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black Jet 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black Jet 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-midori-giant-2',
    name: 'Soybean - Midori Giant 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Midori Giant 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Midori Giant 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-lucky-lion-2',
    name: 'Edamame - Lucky Lion 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Lucky Lion 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Lucky Lion 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-sayamusume-2',
    name: 'Cowpea - Sayamusume 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sayamusume 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Sayamusume 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-shirofumi-2',
    name: 'Mung bean - Shirofumi 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Shirofumi 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Shirofumi 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-california-blackeye-2',
    name: 'Adzuki bean - California Blackeye 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'California Blackeye 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['California Blackeye 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-purple-hull-2',
    name: 'Lentil - Purple Hull 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Purple Hull 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Purple Hull 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-crowder-2',
    name: 'Chickpea - Crowder 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Crowder 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Crowder 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-pinkeye-2',
    name: 'Fava bean - Pinkeye 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pinkeye 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pinkeye 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-mississippi-silver-2',
    name: 'Soybean - Mississippi Silver 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mississippi Silver 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mississippi Silver 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-red-ripper-2',
    name: 'Edamame - Red Ripper 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Ripper 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Ripper 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-texas-cream-2',
    name: 'Cowpea - Texas Cream 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Texas Cream 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Texas Cream 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-elite-2',
    name: 'Mung bean - Elite 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Elite 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Elite 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-iron-clay-2',
    name: 'Adzuki bean - Iron Clay 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Iron Clay 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Iron Clay 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-knuckle-2',
    name: 'Lentil - Knuckle 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Knuckle 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Knuckle 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-golden-2',
    name: 'Chickpea - Golden 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Golden 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Golden 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-green-2',
    name: 'Fava bean - Green 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-black-2',
    name: 'Soybean - Black 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-red-2',
    name: 'Edamame - Red 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-yellow-2',
    name: 'Cowpea - Yellow 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Yellow 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Yellow 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-chinese-red-2',
    name: 'Mung bean - Chinese Red 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese Red 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese Red 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-field-pea-2',
    name: 'Adzuki bean - Field Pea 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Field Pea 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Field Pea 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-southern-2',
    name: 'Lentil - Southern 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Southern 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Southern 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-clay-2',
    name: 'Chickpea - Clay 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Clay 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Clay 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-speckled-2',
    name: 'Fava bean - Speckled 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Speckled 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Speckled 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-small-red-2',
    name: 'Soybean - Small Red 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Small Red 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Small Red 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-large-red-2',
    name: 'Edamame - Large Red 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Large Red 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Large Red 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-red-chief-2',
    name: 'Cowpea - Red Chief 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Chief 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Red Chief 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-takara-2',
    name: 'Mung bean - Takara 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Takara 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Takara 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-erimo-2',
    name: 'Adzuki bean - Erimo 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Erimo 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Erimo 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-green-2',
    name: 'Lentil - Green 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-red-2',
    name: 'Chickpea - Red 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-black-2',
    name: 'Fava bean - Black 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-white-2',
    name: 'Soybean - White 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'White 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['White 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-brown-2',
    name: 'Edamame - Brown 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Brown 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Brown 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-french-2',
    name: 'Cowpea - French 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['French 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-spanish-2',
    name: 'Mung bean - Spanish 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Spanish 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Spanish 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-italian-2',
    name: 'Adzuki bean - Italian 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Italian 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Italian 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-greek-2',
    name: 'Lentil - Greek 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Greek 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Greek 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-turkish-2',
    name: 'Chickpea - Turkish 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Turkish 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Turkish 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-indian-2',
    name: 'Fava bean - Indian 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Indian 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Indian 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-chinese-2',
    name: 'Soybean - Chinese 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-japanese-2',
    name: 'Edamame - Japanese 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Japanese 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Japanese 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-korean-2',
    name: 'Cowpea - Korean 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Korean 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Korean 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-thai-2',
    name: 'Mung bean - Thai 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Thai 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Thai 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-organic-2',
    name: 'Adzuki bean - Organic 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Organic 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Organic 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-heirloom-2',
    name: 'Lentil - Heirloom 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heirloom 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-hybrid-2',
    name: 'Chickpea - Hybrid 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Hybrid 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Hybrid 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-gmo-2',
    name: 'Fava bean - GMO 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'GMO 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['GMO 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-non-gmo-2',
    name: 'Soybean - Non-GMO 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Non-GMO 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Non-GMO 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-dwarf-2',
    name: 'Edamame - Dwarf 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Dwarf 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Dwarf 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-bush-2',
    name: 'Cowpea - Bush 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Bush 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Bush 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-pole-2',
    name: 'Mung bean - Pole 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pole 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pole 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-climbing-2',
    name: 'Adzuki bean - Climbing 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Climbing 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Climbing 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-vining-2',
    name: 'Lentil - Vining 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vining 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vining 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-early-2',
    name: 'Chickpea - Early 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Early 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Early 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-mid-2',
    name: 'Fava bean - Mid 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mid 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mid 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-late-2',
    name: 'Soybean - Late 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Late 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Late 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-main-season-2',
    name: 'Edamame - Main Season 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Main Season 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Main Season 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-all-season-2',
    name: 'Cowpea - All Season 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'All Season 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['All Season 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-drought-tolerant-2',
    name: 'Mung bean - Drought Tolerant 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Drought Tolerant 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Drought Tolerant 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-heat-resistant-2',
    name: 'Adzuki bean - Heat Resistant 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heat Resistant 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heat Resistant 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-cold-hardy-2',
    name: 'Lentil - Cold Hardy 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Cold Hardy 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Cold Hardy 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-disease-resistant-2',
    name: 'Chickpea - Disease Resistant 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Disease Resistant 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Disease Resistant 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-high-yield-2',
    name: 'Fava bean - High Yield 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'High Yield 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['High Yield 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-protein-rich-2',
    name: 'Soybean - Protein Rich 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Protein Rich 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Protein Rich 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-fiber-rich-2',
    name: 'Edamame - Fiber Rich 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Fiber Rich 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Fiber Rich 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-low-fat-2',
    name: 'Cowpea - Low Fat 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Low Fat 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Low Fat 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-gluten-free-2',
    name: 'Mung bean - Gluten Free 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Gluten Free 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Gluten Free 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-vegan-2',
    name: 'Adzuki bean - Vegan 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vegan 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vegan 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-sprouting-2',
    name: 'Lentil - Sprouting 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sprouting 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sprouting 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-drying-2',
    name: 'Chickpea - Drying 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Drying 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Drying 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-canning-2',
    name: 'Fava bean - Canning 2',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Canning 2 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Canning 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-freezing-2',
    name: 'Soybean - Freezing 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Freezing 2 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Freezing 2'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-fresh-2',
    name: 'Edamame - Fresh 2',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Fresh 2 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Fresh 2'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-cover-crop-2',
    name: 'Cowpea - Cover Crop 2',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Cover Crop 2 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Cover Crop 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-nitrogen-fixer-2',
    name: 'Mung bean - Nitrogen Fixer 2',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Nitrogen Fixer 2 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Nitrogen Fixer 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-green-manure-2',
    name: 'Adzuki bean - Green Manure 2',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Manure 2 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green Manure 2'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-forage-2',
    name: 'Lentil - Forage 2',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Forage 2 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Forage 2'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-silage-2',
    name: 'Chickpea - Silage 2',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Silage 2 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Silage 2'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-green-3',
    name: 'Fava bean - Green 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-red-3',
    name: 'Soybean - Red 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-french-green-3',
    name: 'Edamame - French Green 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French Green 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French Green 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-beluga-3',
    name: 'Cowpea - Beluga 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Beluga 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Beluga 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-black-3',
    name: 'Mung bean - Black 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-pardina-3',
    name: 'Adzuki bean - Pardina 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pardina 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pardina 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-masoor-3',
    name: 'Lentil - Masoor 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Masoor 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Masoor 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-urad-3',
    name: 'Chickpea - Urad 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Urad 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Urad 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-toor-3',
    name: 'Fava bean - Toor 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Toor 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Toor 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-chana-dal-3',
    name: 'Soybean - Chana Dal 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chana Dal 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chana Dal 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-kabuli-3',
    name: 'Edamame - Kabuli 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Kabuli 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Kabuli 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-desi-3',
    name: 'Cowpea - Desi 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Desi 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Desi 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-garbanzo-3',
    name: 'Mung bean - Garbanzo 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Garbanzo 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Garbanzo 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-ceci-3',
    name: 'Adzuki bean - Ceci 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Ceci 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Ceci 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-egyptian-3',
    name: 'Lentil - Egyptian 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Egyptian 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Egyptian 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-broad-windsor-3',
    name: 'Chickpea - Broad Windsor 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Broad Windsor 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Broad Windsor 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-aquadulce-3',
    name: 'Fava bean - Aquadulce 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Aquadulce 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Aquadulce 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-sweet-3',
    name: 'Soybean - Sweet 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sweet 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sweet 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-horse-bean-3',
    name: 'Edamame - Horse Bean 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Horse Bean 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Horse Bean 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-tick-3',
    name: 'Cowpea - Tick 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Tick 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Tick 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-edamame-3',
    name: 'Mung bean - Edamame 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Edamame 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Edamame 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-green-shell-3',
    name: 'Adzuki bean - Green Shell 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Shell 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green Shell 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-butterbean-3',
    name: 'Lentil - Butterbean 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Butterbean 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Butterbean 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-envy-3',
    name: 'Chickpea - Envy 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Envy 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Envy 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-besweet-3',
    name: 'Fava bean - BeSweet 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'BeSweet 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['BeSweet 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-black-jet-3',
    name: 'Soybean - Black Jet 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black Jet 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black Jet 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-midori-giant-3',
    name: 'Edamame - Midori Giant 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Midori Giant 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Midori Giant 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-lucky-lion-3',
    name: 'Cowpea - Lucky Lion 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Lucky Lion 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Lucky Lion 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-sayamusume-3',
    name: 'Mung bean - Sayamusume 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sayamusume 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sayamusume 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-shirofumi-3',
    name: 'Adzuki bean - Shirofumi 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Shirofumi 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Shirofumi 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-california-blackeye-3',
    name: 'Lentil - California Blackeye 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'California Blackeye 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['California Blackeye 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-purple-hull-3',
    name: 'Chickpea - Purple Hull 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Purple Hull 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Purple Hull 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-crowder-3',
    name: 'Fava bean - Crowder 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Crowder 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Crowder 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-pinkeye-3',
    name: 'Soybean - Pinkeye 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pinkeye 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pinkeye 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-mississippi-silver-3',
    name: 'Edamame - Mississippi Silver 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mississippi Silver 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mississippi Silver 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-red-ripper-3',
    name: 'Cowpea - Red Ripper 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Ripper 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Red Ripper 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-texas-cream-3',
    name: 'Mung bean - Texas Cream 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Texas Cream 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Texas Cream 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-elite-3',
    name: 'Adzuki bean - Elite 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Elite 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Elite 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-iron-clay-3',
    name: 'Lentil - Iron Clay 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Iron Clay 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Iron Clay 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-knuckle-3',
    name: 'Chickpea - Knuckle 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Knuckle 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Knuckle 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-golden-3',
    name: 'Fava bean - Golden 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Golden 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Golden 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-green-3',
    name: 'Soybean - Green 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-black-3',
    name: 'Edamame - Black 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-red-3',
    name: 'Cowpea - Red 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Red 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-yellow-3',
    name: 'Mung bean - Yellow 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Yellow 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Yellow 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-chinese-red-3',
    name: 'Adzuki bean - Chinese Red 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese Red 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese Red 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-field-pea-3',
    name: 'Lentil - Field Pea 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Field Pea 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Field Pea 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-southern-3',
    name: 'Chickpea - Southern 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Southern 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Southern 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-clay-3',
    name: 'Fava bean - Clay 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Clay 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Clay 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-speckled-3',
    name: 'Soybean - Speckled 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Speckled 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Speckled 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-small-red-3',
    name: 'Edamame - Small Red 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Small Red 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Small Red 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-large-red-3',
    name: 'Cowpea - Large Red 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Large Red 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Large Red 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-red-chief-3',
    name: 'Mung bean - Red Chief 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Chief 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Chief 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-takara-3',
    name: 'Adzuki bean - Takara 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Takara 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Takara 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-erimo-3',
    name: 'Lentil - Erimo 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Erimo 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Erimo 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-green-3',
    name: 'Chickpea - Green 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-red-3',
    name: 'Fava bean - Red 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-black-3',
    name: 'Soybean - Black 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-white-3',
    name: 'Edamame - White 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'White 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['White 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-brown-3',
    name: 'Cowpea - Brown 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Brown 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Brown 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-french-3',
    name: 'Mung bean - French 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-spanish-3',
    name: 'Adzuki bean - Spanish 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Spanish 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Spanish 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-italian-3',
    name: 'Lentil - Italian 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Italian 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Italian 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-greek-3',
    name: 'Chickpea - Greek 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Greek 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Greek 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-turkish-3',
    name: 'Fava bean - Turkish 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Turkish 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Turkish 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-indian-3',
    name: 'Soybean - Indian 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Indian 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Indian 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-chinese-3',
    name: 'Edamame - Chinese 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-japanese-3',
    name: 'Cowpea - Japanese 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Japanese 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Japanese 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-korean-3',
    name: 'Mung bean - Korean 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Korean 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Korean 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-thai-3',
    name: 'Adzuki bean - Thai 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Thai 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Thai 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-organic-3',
    name: 'Lentil - Organic 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Organic 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Organic 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-heirloom-3',
    name: 'Chickpea - Heirloom 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heirloom 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-hybrid-3',
    name: 'Fava bean - Hybrid 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Hybrid 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Hybrid 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-gmo-3',
    name: 'Soybean - GMO 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'GMO 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['GMO 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-non-gmo-3',
    name: 'Edamame - Non-GMO 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Non-GMO 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Non-GMO 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-dwarf-3',
    name: 'Cowpea - Dwarf 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Dwarf 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Dwarf 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-bush-3',
    name: 'Mung bean - Bush 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Bush 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Bush 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-pole-3',
    name: 'Adzuki bean - Pole 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pole 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pole 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-climbing-3',
    name: 'Lentil - Climbing 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Climbing 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Climbing 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-vining-3',
    name: 'Chickpea - Vining 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vining 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vining 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-early-3',
    name: 'Fava bean - Early 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Early 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Early 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-mid-3',
    name: 'Soybean - Mid 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mid 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mid 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-late-3',
    name: 'Edamame - Late 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Late 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Late 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-main-season-3',
    name: 'Cowpea - Main Season 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Main Season 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Main Season 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-all-season-3',
    name: 'Mung bean - All Season 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'All Season 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['All Season 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-drought-tolerant-3',
    name: 'Adzuki bean - Drought Tolerant 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Drought Tolerant 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Drought Tolerant 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-heat-resistant-3',
    name: 'Lentil - Heat Resistant 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heat Resistant 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heat Resistant 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-cold-hardy-3',
    name: 'Chickpea - Cold Hardy 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Cold Hardy 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Cold Hardy 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-disease-resistant-3',
    name: 'Fava bean - Disease Resistant 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Disease Resistant 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Disease Resistant 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-high-yield-3',
    name: 'Soybean - High Yield 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'High Yield 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['High Yield 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-protein-rich-3',
    name: 'Edamame - Protein Rich 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Protein Rich 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Protein Rich 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-fiber-rich-3',
    name: 'Cowpea - Fiber Rich 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Fiber Rich 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Fiber Rich 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-low-fat-3',
    name: 'Mung bean - Low Fat 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Low Fat 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Low Fat 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-gluten-free-3',
    name: 'Adzuki bean - Gluten Free 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Gluten Free 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Gluten Free 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-vegan-3',
    name: 'Lentil - Vegan 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vegan 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vegan 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-sprouting-3',
    name: 'Chickpea - Sprouting 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sprouting 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sprouting 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-drying-3',
    name: 'Fava bean - Drying 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Drying 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Drying 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-canning-3',
    name: 'Soybean - Canning 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Canning 3 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Canning 3'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-freezing-3',
    name: 'Edamame - Freezing 3',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Freezing 3 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Freezing 3'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-fresh-3',
    name: 'Cowpea - Fresh 3',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Fresh 3 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Fresh 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-cover-crop-3',
    name: 'Mung bean - Cover Crop 3',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Cover Crop 3 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Cover Crop 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-nitrogen-fixer-3',
    name: 'Adzuki bean - Nitrogen Fixer 3',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Nitrogen Fixer 3 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Nitrogen Fixer 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-green-manure-3',
    name: 'Lentil - Green Manure 3',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Manure 3 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green Manure 3'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-forage-3',
    name: 'Chickpea - Forage 3',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Forage 3 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Forage 3'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-silage-3',
    name: 'Fava bean - Silage 3',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Silage 3 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Silage 3'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-green-4',
    name: 'Soybean - Green 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-red-4',
    name: 'Edamame - Red 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-french-green-4',
    name: 'Cowpea - French Green 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French Green 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['French Green 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-beluga-4',
    name: 'Mung bean - Beluga 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Beluga 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Beluga 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-black-4',
    name: 'Adzuki bean - Black 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-pardina-4',
    name: 'Lentil - Pardina 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pardina 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pardina 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-masoor-4',
    name: 'Chickpea - Masoor 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Masoor 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Masoor 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-urad-4',
    name: 'Fava bean - Urad 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Urad 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Urad 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-toor-4',
    name: 'Soybean - Toor 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Toor 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Toor 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-chana-dal-4',
    name: 'Edamame - Chana Dal 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chana Dal 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chana Dal 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-kabuli-4',
    name: 'Cowpea - Kabuli 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Kabuli 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Kabuli 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-desi-4',
    name: 'Mung bean - Desi 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Desi 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Desi 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-garbanzo-4',
    name: 'Adzuki bean - Garbanzo 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Garbanzo 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Garbanzo 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-ceci-4',
    name: 'Lentil - Ceci 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Ceci 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Ceci 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-egyptian-4',
    name: 'Chickpea - Egyptian 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Egyptian 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Egyptian 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-broad-windsor-4',
    name: 'Fava bean - Broad Windsor 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Broad Windsor 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Broad Windsor 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-aquadulce-4',
    name: 'Soybean - Aquadulce 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Aquadulce 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Aquadulce 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-sweet-4',
    name: 'Edamame - Sweet 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sweet 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sweet 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-horse-bean-4',
    name: 'Cowpea - Horse Bean 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Horse Bean 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Horse Bean 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-tick-4',
    name: 'Mung bean - Tick 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Tick 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Tick 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-edamame-4',
    name: 'Adzuki bean - Edamame 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Edamame 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Edamame 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-green-shell-4',
    name: 'Lentil - Green Shell 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Shell 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green Shell 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-butterbean-4',
    name: 'Chickpea - Butterbean 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Butterbean 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Butterbean 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-envy-4',
    name: 'Fava bean - Envy 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Envy 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Envy 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-besweet-4',
    name: 'Soybean - BeSweet 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'BeSweet 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['BeSweet 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-black-jet-4',
    name: 'Edamame - Black Jet 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black Jet 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black Jet 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-midori-giant-4',
    name: 'Cowpea - Midori Giant 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Midori Giant 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Midori Giant 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-lucky-lion-4',
    name: 'Mung bean - Lucky Lion 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Lucky Lion 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Lucky Lion 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-sayamusume-4',
    name: 'Adzuki bean - Sayamusume 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sayamusume 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sayamusume 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-shirofumi-4',
    name: 'Lentil - Shirofumi 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Shirofumi 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Shirofumi 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-california-blackeye-4',
    name: 'Chickpea - California Blackeye 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'California Blackeye 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['California Blackeye 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-purple-hull-4',
    name: 'Fava bean - Purple Hull 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Purple Hull 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Purple Hull 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-crowder-4',
    name: 'Soybean - Crowder 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Crowder 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Crowder 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-pinkeye-4',
    name: 'Edamame - Pinkeye 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pinkeye 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pinkeye 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-mississippi-silver-4',
    name: 'Cowpea - Mississippi Silver 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mississippi Silver 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Mississippi Silver 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-red-ripper-4',
    name: 'Mung bean - Red Ripper 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Ripper 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Ripper 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-texas-cream-4',
    name: 'Adzuki bean - Texas Cream 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Texas Cream 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Texas Cream 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-elite-4',
    name: 'Lentil - Elite 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Elite 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Elite 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-iron-clay-4',
    name: 'Chickpea - Iron Clay 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Iron Clay 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Iron Clay 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-knuckle-4',
    name: 'Fava bean - Knuckle 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Knuckle 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Knuckle 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-golden-4',
    name: 'Soybean - Golden 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Golden 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Golden 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-green-4',
    name: 'Edamame - Green 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-black-4',
    name: 'Cowpea - Black 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Black 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-red-4',
    name: 'Mung bean - Red 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-yellow-4',
    name: 'Adzuki bean - Yellow 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Yellow 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Yellow 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-chinese-red-4',
    name: 'Lentil - Chinese Red 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese Red 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese Red 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-field-pea-4',
    name: 'Chickpea - Field Pea 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Field Pea 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Field Pea 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-southern-4',
    name: 'Fava bean - Southern 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Southern 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Southern 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-clay-4',
    name: 'Soybean - Clay 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Clay 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Clay 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-speckled-4',
    name: 'Edamame - Speckled 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Speckled 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Speckled 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-small-red-4',
    name: 'Cowpea - Small Red 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Small Red 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Small Red 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-large-red-4',
    name: 'Mung bean - Large Red 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Large Red 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Large Red 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-red-chief-4',
    name: 'Adzuki bean - Red Chief 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Chief 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Chief 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-takara-4',
    name: 'Lentil - Takara 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Takara 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Takara 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-erimo-4',
    name: 'Chickpea - Erimo 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Erimo 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Erimo 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-green-4',
    name: 'Fava bean - Green 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-red-4',
    name: 'Soybean - Red 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-black-4',
    name: 'Edamame - Black 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-white-4',
    name: 'Cowpea - White 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'White 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['White 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-brown-4',
    name: 'Mung bean - Brown 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Brown 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Brown 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-french-4',
    name: 'Adzuki bean - French 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-spanish-4',
    name: 'Lentil - Spanish 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Spanish 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Spanish 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-italian-4',
    name: 'Chickpea - Italian 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Italian 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Italian 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-greek-4',
    name: 'Fava bean - Greek 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Greek 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Greek 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-turkish-4',
    name: 'Soybean - Turkish 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Turkish 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Turkish 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-indian-4',
    name: 'Edamame - Indian 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Indian 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Indian 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-chinese-4',
    name: 'Cowpea - Chinese 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Chinese 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-japanese-4',
    name: 'Mung bean - Japanese 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Japanese 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Japanese 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-korean-4',
    name: 'Adzuki bean - Korean 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Korean 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Korean 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-thai-4',
    name: 'Lentil - Thai 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Thai 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Thai 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-organic-4',
    name: 'Chickpea - Organic 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Organic 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Organic 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-heirloom-4',
    name: 'Fava bean - Heirloom 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heirloom 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-hybrid-4',
    name: 'Soybean - Hybrid 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Hybrid 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Hybrid 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-gmo-4',
    name: 'Edamame - GMO 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'GMO 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['GMO 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-non-gmo-4',
    name: 'Cowpea - Non-GMO 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Non-GMO 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Non-GMO 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-dwarf-4',
    name: 'Mung bean - Dwarf 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Dwarf 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Dwarf 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-bush-4',
    name: 'Adzuki bean - Bush 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Bush 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Bush 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-pole-4',
    name: 'Lentil - Pole 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pole 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pole 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-climbing-4',
    name: 'Chickpea - Climbing 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Climbing 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Climbing 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-vining-4',
    name: 'Fava bean - Vining 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vining 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vining 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-early-4',
    name: 'Soybean - Early 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Early 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Early 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-mid-4',
    name: 'Edamame - Mid 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mid 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mid 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-late-4',
    name: 'Cowpea - Late 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Late 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Late 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-main-season-4',
    name: 'Mung bean - Main Season 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Main Season 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Main Season 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-all-season-4',
    name: 'Adzuki bean - All Season 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'All Season 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['All Season 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-drought-tolerant-4',
    name: 'Lentil - Drought Tolerant 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Drought Tolerant 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Drought Tolerant 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-heat-resistant-4',
    name: 'Chickpea - Heat Resistant 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heat Resistant 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heat Resistant 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-cold-hardy-4',
    name: 'Fava bean - Cold Hardy 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Cold Hardy 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Cold Hardy 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-disease-resistant-4',
    name: 'Soybean - Disease Resistant 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Disease Resistant 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Disease Resistant 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-high-yield-4',
    name: 'Edamame - High Yield 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'High Yield 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['High Yield 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-protein-rich-4',
    name: 'Cowpea - Protein Rich 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Protein Rich 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Protein Rich 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-fiber-rich-4',
    name: 'Mung bean - Fiber Rich 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Fiber Rich 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Fiber Rich 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-low-fat-4',
    name: 'Adzuki bean - Low Fat 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Low Fat 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Low Fat 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-gluten-free-4',
    name: 'Lentil - Gluten Free 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Gluten Free 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Gluten Free 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-vegan-4',
    name: 'Chickpea - Vegan 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vegan 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vegan 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-sprouting-4',
    name: 'Fava bean - Sprouting 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sprouting 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sprouting 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-drying-4',
    name: 'Soybean - Drying 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Drying 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Drying 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-canning-4',
    name: 'Edamame - Canning 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Canning 4 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Canning 4'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-freezing-4',
    name: 'Cowpea - Freezing 4',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Freezing 4 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Freezing 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-fresh-4',
    name: 'Mung bean - Fresh 4',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Fresh 4 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Fresh 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-cover-crop-4',
    name: 'Adzuki bean - Cover Crop 4',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Cover Crop 4 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Cover Crop 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-nitrogen-fixer-4',
    name: 'Lentil - Nitrogen Fixer 4',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Nitrogen Fixer 4 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Nitrogen Fixer 4'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-green-manure-4',
    name: 'Chickpea - Green Manure 4',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Manure 4 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green Manure 4'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-forage-4',
    name: 'Fava bean - Forage 4',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Forage 4 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Forage 4'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-silage-4',
    name: 'Soybean - Silage 4',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Silage 4 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Silage 4'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-green-5',
    name: 'Edamame - Green 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-red-5',
    name: 'Cowpea - Red 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Red 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-french-green-5',
    name: 'Mung bean - French Green 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French Green 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French Green 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-beluga-5',
    name: 'Adzuki bean - Beluga 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Beluga 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Beluga 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-black-5',
    name: 'Lentil - Black 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-pardina-5',
    name: 'Chickpea - Pardina 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pardina 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pardina 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-masoor-5',
    name: 'Fava bean - Masoor 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Masoor 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Masoor 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-urad-5',
    name: 'Soybean - Urad 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Urad 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Urad 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-toor-5',
    name: 'Edamame - Toor 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Toor 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Toor 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-chana-dal-5',
    name: 'Cowpea - Chana Dal 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chana Dal 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Chana Dal 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-kabuli-5',
    name: 'Mung bean - Kabuli 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Kabuli 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Kabuli 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-desi-5',
    name: 'Adzuki bean - Desi 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Desi 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Desi 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-garbanzo-5',
    name: 'Lentil - Garbanzo 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Garbanzo 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Garbanzo 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-ceci-5',
    name: 'Chickpea - Ceci 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Ceci 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Ceci 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-egyptian-5',
    name: 'Fava bean - Egyptian 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Egyptian 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Egyptian 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-broad-windsor-5',
    name: 'Soybean - Broad Windsor 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Broad Windsor 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Broad Windsor 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-aquadulce-5',
    name: 'Edamame - Aquadulce 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Aquadulce 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Aquadulce 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-sweet-5',
    name: 'Cowpea - Sweet 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sweet 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Sweet 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-horse-bean-5',
    name: 'Mung bean - Horse Bean 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Horse Bean 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Horse Bean 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-tick-5',
    name: 'Adzuki bean - Tick 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Tick 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Tick 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-edamame-5',
    name: 'Lentil - Edamame 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Edamame 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Edamame 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-green-shell-5',
    name: 'Chickpea - Green Shell 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green Shell 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green Shell 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-butterbean-5',
    name: 'Fava bean - Butterbean 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Butterbean 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Butterbean 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-envy-5',
    name: 'Soybean - Envy 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Envy 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Envy 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-besweet-5',
    name: 'Edamame - BeSweet 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'BeSweet 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['BeSweet 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-black-jet-5',
    name: 'Cowpea - Black Jet 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black Jet 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Black Jet 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-midori-giant-5',
    name: 'Mung bean - Midori Giant 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Midori Giant 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Midori Giant 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-lucky-lion-5',
    name: 'Adzuki bean - Lucky Lion 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Lucky Lion 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Lucky Lion 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-sayamusume-5',
    name: 'Lentil - Sayamusume 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Sayamusume 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Sayamusume 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-shirofumi-5',
    name: 'Chickpea - Shirofumi 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Shirofumi 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Shirofumi 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-california-blackeye-5',
    name: 'Fava bean - California Blackeye 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'California Blackeye 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['California Blackeye 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-purple-hull-5',
    name: 'Soybean - Purple Hull 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Purple Hull 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Purple Hull 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-crowder-5',
    name: 'Edamame - Crowder 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Crowder 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Crowder 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-pinkeye-5',
    name: 'Cowpea - Pinkeye 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pinkeye 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Pinkeye 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-mississippi-silver-5',
    name: 'Mung bean - Mississippi Silver 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Mississippi Silver 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Mississippi Silver 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-red-ripper-5',
    name: 'Adzuki bean - Red Ripper 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Ripper 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Ripper 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-texas-cream-5',
    name: 'Lentil - Texas Cream 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Texas Cream 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Texas Cream 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-elite-5',
    name: 'Chickpea - Elite 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Elite 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Elite 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-iron-clay-5',
    name: 'Fava bean - Iron Clay 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Iron Clay 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Iron Clay 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-knuckle-5',
    name: 'Soybean - Knuckle 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Knuckle 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Knuckle 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-golden-5',
    name: 'Edamame - Golden 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Golden 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Golden 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-green-5',
    name: 'Cowpea - Green 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Green 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-black-5',
    name: 'Mung bean - Black 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Black 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-red-5',
    name: 'Adzuki bean - Red 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-yellow-5',
    name: 'Lentil - Yellow 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Yellow 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Yellow 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-chinese-red-5',
    name: 'Chickpea - Chinese Red 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese Red 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese Red 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-field-pea-5',
    name: 'Fava bean - Field Pea 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Field Pea 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Field Pea 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-southern-5',
    name: 'Soybean - Southern 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Southern 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Southern 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-clay-5',
    name: 'Edamame - Clay 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Clay 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Clay 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-speckled-5',
    name: 'Cowpea - Speckled 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Speckled 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Speckled 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-small-red-5',
    name: 'Mung bean - Small Red 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Small Red 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Small Red 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-large-red-5',
    name: 'Adzuki bean - Large Red 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Large Red 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Large Red 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-red-chief-5',
    name: 'Lentil - Red Chief 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red Chief 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red Chief 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-takara-5',
    name: 'Chickpea - Takara 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Takara 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Takara 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-erimo-5',
    name: 'Fava bean - Erimo 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Erimo 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Erimo 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-green-5',
    name: 'Soybean - Green 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Green 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Green 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-red-5',
    name: 'Edamame - Red 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Red 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Red 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-black-5',
    name: 'Cowpea - Black 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Black 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Black 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-white-5',
    name: 'Mung bean - White 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'White 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['White 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-brown-5',
    name: 'Adzuki bean - Brown 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Brown 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Brown 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-french-5',
    name: 'Lentil - French 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'French 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['French 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-spanish-5',
    name: 'Chickpea - Spanish 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Spanish 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Spanish 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-italian-5',
    name: 'Fava bean - Italian 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Italian 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Italian 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-greek-5',
    name: 'Soybean - Greek 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Greek 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Greek 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-turkish-5',
    name: 'Edamame - Turkish 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Turkish 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Turkish 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-indian-5',
    name: 'Cowpea - Indian 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Indian 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['Indian 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-chinese-5',
    name: 'Mung bean - Chinese 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Chinese 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Chinese 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-japanese-5',
    name: 'Adzuki bean - Japanese 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Japanese 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Japanese 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-korean-5',
    name: 'Lentil - Korean 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Korean 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Korean 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-thai-5',
    name: 'Chickpea - Thai 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Thai 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Thai 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-organic-5',
    name: 'Fava bean - Organic 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Organic 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Organic 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-heirloom-5',
    name: 'Soybean - Heirloom 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Heirloom 5'],
    uses: ['tofu', 'milk', 'edamame']
  },
  {
    id: 'edamame-hybrid-5',
    name: 'Edamame - Hybrid 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Hybrid 5 edamame. Fresh green soybeans, snack favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Hybrid 5'],
    uses: ['snacking', 'salads', 'rice']
  },
  {
    id: 'cowpea-gmo-5',
    name: 'Cowpea - GMO 5',
    scientificName: 'Vigna unguiculata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'GMO 5 cowpea. Southern favorite, heat tolerant. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: 'vines to 8 feet',
    spread: 'indefinite',
    family: 'Fabaceae',
    varieties: ['GMO 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'mung-bean-non-gmo-5',
    name: 'Mung bean - Non-GMO 5',
    scientificName: 'Vigna radiata',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Non-GMO 5 mung bean. Sprouting favorite, Asian cuisine. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Non-GMO 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'adzuki-bean-dwarf-5',
    name: 'Adzuki bean - Dwarf 5',
    scientificName: 'Vigna angularis',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Dwarf 5 adzuki bean. Sweet red bean, dessert favorite. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Dwarf 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'lentil-bush-5',
    name: 'Lentil - Bush 5',
    scientificName: 'Lens culinaris',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Bush 5 lentil. Protein-rich legume, quick cooking. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Bush 5'],
    uses: ['soup', 'dal', 'curry']
  },
  {
    id: 'chickpea-pole-5',
    name: 'Chickpea - Pole 5',
    scientificName: 'Cicer arietinum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 6,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Pole 5 chickpea. Versatile for hummus and curries. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Pole 5'],
    uses: ['hummus', 'curry', 'salads']
  },
  {
    id: 'fava-bean-climbing-5',
    name: 'Fava bean - Climbing 5',
    scientificName: 'Vicia faba',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Climbing 5 fava bean. Large beans, cool weather crop. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Climbing 5'],
    uses: ['cooking', 'soup', 'stew']
  },
  {
    id: 'soybean-vining-5',
    name: 'Soybean - Vining 5',
    scientificName: 'Glycine max',
    category: 'legume',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Vining 5 soybean. High protein, many uses. Nitrogen-fixing legume.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Vining 5'],
    uses: ['tofu', 'milk', 'edamame']
  }
,
  {
    id: 'asparagus-mary-washington',
    name: 'Asparagus - Mary Washington',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Mary Washington asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Mary Washington'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-jersey-giant',
    name: 'Rhubarb - Jersey Giant',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Jersey Giant rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Jersey Giant'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-jersey-knight',
    name: 'Artichoke - Jersey Knight',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jersey Knight artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Jersey Knight'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-purple-passion',
    name: 'Cardoon - Purple Passion',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Passion cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Purple Passion'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-apollo',
    name: 'Okra - Apollo',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apollo okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Apollo'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-uc-157',
    name: 'Chayote - UC 157',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'UC 157 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['UC 157'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-atlas',
    name: 'Jicama - Atlas',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Atlas jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Atlas'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-grande',
    name: 'Kohlrabi - Grande',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grande kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Grande'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-precoce',
    name: 'Celeriac - Precoce',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Precoce celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Precoce'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-argenteuil',
    name: 'Fennel - Argenteuil',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Argenteuil fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Argenteuil'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-victoria',
    name: 'Asparagus - Victoria',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Victoria asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Victoria'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-crimson-red',
    name: 'Rhubarb - Crimson Red',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Crimson Red rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Crimson Red'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-canada-red',
    name: 'Artichoke - Canada Red',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Canada Red artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Canada Red'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-valentine',
    name: 'Cardoon - Valentine',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Valentine cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Valentine'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-macdonald',
    name: 'Okra - MacDonald',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'MacDonald okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['MacDonald'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-green',
    name: 'Chayote - Green',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-red',
    name: 'Jicama - Red',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Red'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-pink',
    name: 'Kohlrabi - Pink',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pink kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Pink'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-cherry',
    name: 'Celeriac - Cherry',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cherry celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Cherry'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-strawberry',
    name: 'Fennel - Strawberry',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Strawberry fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Strawberry'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-green-globe',
    name: 'Asparagus - Green Globe',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Green Globe asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Green Globe'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-imperial-star',
    name: 'Rhubarb - Imperial Star',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Imperial Star rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Imperial Star'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-violetto',
    name: 'Artichoke - Violetto',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Violetto artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Violetto'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-purple',
    name: 'Cardoon - Purple',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Purple'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-romanesco',
    name: 'Okra - Romanesco',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Romanesco okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Romanesco'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-cardoon',
    name: 'Chayote - Cardoon',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cardoon chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cardoon'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-spanish',
    name: 'Jicama - Spanish',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Spanish'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-portuguese',
    name: 'Kohlrabi - Portuguese',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Portuguese kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Portuguese'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-gobbo',
    name: 'Celeriac - Gobbo',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gobbo celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Gobbo'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-giant',
    name: 'Fennel - Giant',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Giant'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-clemson-spineless',
    name: 'Asparagus - Clemson Spineless',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Clemson Spineless asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Clemson Spineless'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-emerald',
    name: 'Rhubarb - Emerald',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Emerald rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Emerald'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-annie-oakley',
    name: 'Artichoke - Annie Oakley',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Annie Oakley artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Annie Oakley'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-burgundy',
    name: 'Cardoon - Burgundy',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Burgundy cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Burgundy'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-red',
    name: 'Okra - Red',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Red'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-jambalaya',
    name: 'Chayote - Jambalaya',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jambalaya chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jambalaya'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-cajun-delight',
    name: 'Jicama - Cajun Delight',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cajun Delight jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Cajun Delight'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-louisiana-green',
    name: 'Kohlrabi - Louisiana Green',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Louisiana Green kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Louisiana Green'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-silver-queen',
    name: 'Celeriac - Silver Queen',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Silver Queen celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Silver Queen'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-star-of-david',
    name: 'Fennel - Star of David',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Star of David fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Star of David'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-christophine',
    name: 'Asparagus - Christophine',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Christophine asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Christophine'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-mirliton',
    name: 'Rhubarb - Mirliton',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Mirliton rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Mirliton'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-choko',
    name: 'Artichoke - Choko',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Choko artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Choko'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-vegetable-pear',
    name: 'Cardoon - Vegetable Pear',
    scientificName: 'Cynara cardunculus',
    category: 'legume',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vegetable Pear cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Vegetable Pear'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-one-seeded-cucumber',
    name: 'Okra - One-Seeded Cucumber',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'One-Seeded Cucumber okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['One-Seeded Cucumber'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-mexican-turnip',
    name: 'Chayote - Mexican Turnip',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mexican Turnip chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mexican Turnip'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-yam-bean',
    name: 'Jicama - Yam Bean',
    scientificName: 'Pachyrhizus erosus',
    category: 'legume',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yam Bean jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Yam Bean'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-pachyrhizus',
    name: 'Kohlrabi - Pachyrhizus',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pachyrhizus kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Pachyrhizus'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-jicama-de-agua',
    name: 'Celeriac - Jicama de Agua',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jicama de Agua celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Jicama de Agua'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-jicama-de-leche',
    name: 'Fennel - Jicama de Leche',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jicama de Leche fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Jicama de Leche'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-white-vienna',
    name: 'Asparagus - White Vienna',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'White Vienna asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['White Vienna'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-purple-vienna',
    name: 'Rhubarb - Purple Vienna',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Purple Vienna rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Purple Vienna'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-grand-duke',
    name: 'Artichoke - Grand Duke',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grand Duke artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Grand Duke'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-korridor',
    name: 'Cardoon - Korridor',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korridor cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Korridor'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-kossak',
    name: 'Okra - Kossak',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kossak okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Kossak'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-brilliant',
    name: 'Chayote - Brilliant',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brilliant chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Brilliant'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-monarch',
    name: 'Jicama - Monarch',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monarch jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Monarch'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-prague',
    name: 'Kohlrabi - Prague',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prague kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Prague'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-tellus',
    name: 'Celeriac - Tellus',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tellus celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Tellus'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-alabaster',
    name: 'Fennel - Alabaster',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alabaster fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Alabaster'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-florence',
    name: 'Asparagus - Florence',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Florence asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Florence'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-perfection',
    name: 'Rhubarb - Perfection',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Perfection rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Perfection'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-zefa-fino',
    name: 'Artichoke - Zefa Fino',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zefa Fino artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Zefa Fino'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-orion',
    name: 'Cardoon - Orion',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Orion cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Orion'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-preludio',
    name: 'Okra - Preludio',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Preludio okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Preludio'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-bronze',
    name: 'Chayote - Bronze',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bronze chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bronze'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-smokey',
    name: 'Jicama - Smokey',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smokey jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Smokey'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-sweet',
    name: 'Kohlrabi - Sweet',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Sweet'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-bitter',
    name: 'Celeriac - Bitter',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Bitter'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-wild',
    name: 'Fennel - Wild',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wild fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Wild'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-early',
    name: 'Asparagus - Early',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Early asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Early'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-mid',
    name: 'Rhubarb - Mid',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Mid rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Mid'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-late',
    name: 'Artichoke - Late',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Late artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Late'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-main-season',
    name: 'Cardoon - Main Season',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Main Season cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Main Season'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-all-season',
    name: 'Okra - All Season',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'All Season okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['All Season'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-spring',
    name: 'Chayote - Spring',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spring chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spring'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-summer',
    name: 'Jicama - Summer',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Summer jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Summer'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-fall',
    name: 'Kohlrabi - Fall',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fall kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Fall'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-winter',
    name: 'Celeriac - Winter',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winter celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Winter'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-perennial',
    name: 'Fennel - Perennial',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Perennial fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Perennial'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-annual',
    name: 'Asparagus - Annual',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Annual asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Annual'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-biennial',
    name: 'Rhubarb - Biennial',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Biennial rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Biennial'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-dwarf',
    name: 'Artichoke - Dwarf',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Dwarf'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-giant',
    name: 'Cardoon - Giant',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Giant'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-standard',
    name: 'Okra - Standard',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Standard'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-green',
    name: 'Chayote - Green',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-red',
    name: 'Jicama - Red',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Red'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-purple',
    name: 'Kohlrabi - Purple',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Purple'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-white',
    name: 'Celeriac - White',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['White'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-yellow',
    name: 'Fennel - Yellow',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Yellow'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-heirloom',
    name: 'Asparagus - Heirloom',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Heirloom'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-heritage',
    name: 'Rhubarb - Heritage',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Heritage rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Heritage'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-organic',
    name: 'Artichoke - Organic',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Organic'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-hybrid',
    name: 'Cardoon - Hybrid',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Hybrid'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-f1',
    name: 'Okra - F1',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'F1 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['F1'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-disease-resistant',
    name: 'Chayote - Disease Resistant',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Disease Resistant chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Disease Resistant'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-heat-tolerant',
    name: 'Jicama - Heat Tolerant',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heat Tolerant jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Heat Tolerant'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-cold-hardy',
    name: 'Kohlrabi - Cold Hardy',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cold Hardy kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Cold Hardy'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-drought-tolerant',
    name: 'Celeriac - Drought Tolerant',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Drought Tolerant celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Drought Tolerant'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-high-yield',
    name: 'Fennel - High Yield',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'High Yield fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['High Yield'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-mary-washington-2',
    name: 'Asparagus - Mary Washington 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Mary Washington 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Mary Washington 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-jersey-giant-2',
    name: 'Rhubarb - Jersey Giant 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Jersey Giant 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Jersey Giant 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-jersey-knight-2',
    name: 'Artichoke - Jersey Knight 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jersey Knight 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Jersey Knight 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-purple-passion-2',
    name: 'Cardoon - Purple Passion 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Passion 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Purple Passion 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-apollo-2',
    name: 'Okra - Apollo 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apollo 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Apollo 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-uc-157-2',
    name: 'Chayote - UC 157 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'UC 157 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['UC 157 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-atlas-2',
    name: 'Jicama - Atlas 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Atlas 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Atlas 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-grande-2',
    name: 'Kohlrabi - Grande 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grande 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Grande 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-precoce-2',
    name: 'Celeriac - Precoce 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Precoce 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Precoce 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-argenteuil-2',
    name: 'Fennel - Argenteuil 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Argenteuil 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Argenteuil 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-victoria-2',
    name: 'Asparagus - Victoria 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Victoria 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Victoria 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-crimson-red-2',
    name: 'Rhubarb - Crimson Red 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Crimson Red 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Crimson Red 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-canada-red-2',
    name: 'Artichoke - Canada Red 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Canada Red 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Canada Red 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-valentine-2',
    name: 'Cardoon - Valentine 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Valentine 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Valentine 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-macdonald-2',
    name: 'Okra - MacDonald 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'MacDonald 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['MacDonald 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-green-2',
    name: 'Chayote - Green 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-red-2',
    name: 'Jicama - Red 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Red 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-pink-2',
    name: 'Kohlrabi - Pink 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pink 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Pink 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-cherry-2',
    name: 'Celeriac - Cherry 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cherry 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Cherry 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-strawberry-2',
    name: 'Fennel - Strawberry 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Strawberry 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Strawberry 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-green-globe-2',
    name: 'Asparagus - Green Globe 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Green Globe 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Green Globe 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-imperial-star-2',
    name: 'Rhubarb - Imperial Star 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Imperial Star 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Imperial Star 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-violetto-2',
    name: 'Artichoke - Violetto 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Violetto 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Violetto 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-purple-2',
    name: 'Cardoon - Purple 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Purple 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-romanesco-2',
    name: 'Okra - Romanesco 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Romanesco 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Romanesco 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-cardoon-2',
    name: 'Chayote - Cardoon 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cardoon 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cardoon 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-spanish-2',
    name: 'Jicama - Spanish 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Spanish 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-portuguese-2',
    name: 'Kohlrabi - Portuguese 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Portuguese 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Portuguese 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-gobbo-2',
    name: 'Celeriac - Gobbo 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gobbo 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Gobbo 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-giant-2',
    name: 'Fennel - Giant 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Giant 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-clemson-spineless-2',
    name: 'Asparagus - Clemson Spineless 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Clemson Spineless 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Clemson Spineless 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-emerald-2',
    name: 'Rhubarb - Emerald 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Emerald 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Emerald 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-annie-oakley-2',
    name: 'Artichoke - Annie Oakley 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Annie Oakley 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Annie Oakley 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-burgundy-2',
    name: 'Cardoon - Burgundy 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Burgundy 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Burgundy 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-red-2',
    name: 'Okra - Red 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Red 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-jambalaya-2',
    name: 'Chayote - Jambalaya 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jambalaya 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jambalaya 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-cajun-delight-2',
    name: 'Jicama - Cajun Delight 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cajun Delight 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Cajun Delight 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-louisiana-green-2',
    name: 'Kohlrabi - Louisiana Green 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Louisiana Green 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Louisiana Green 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-silver-queen-2',
    name: 'Celeriac - Silver Queen 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Silver Queen 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Silver Queen 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-star-of-david-2',
    name: 'Fennel - Star of David 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Star of David 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Star of David 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-christophine-2',
    name: 'Asparagus - Christophine 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Christophine 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Christophine 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-mirliton-2',
    name: 'Rhubarb - Mirliton 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Mirliton 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Mirliton 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-choko-2',
    name: 'Artichoke - Choko 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Choko 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Choko 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-vegetable-pear-2',
    name: 'Cardoon - Vegetable Pear 2',
    scientificName: 'Cynara cardunculus',
    category: 'legume',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vegetable Pear 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Vegetable Pear 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-one-seeded-cucumber-2',
    name: 'Okra - One-Seeded Cucumber 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'One-Seeded Cucumber 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['One-Seeded Cucumber 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-mexican-turnip-2',
    name: 'Chayote - Mexican Turnip 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mexican Turnip 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mexican Turnip 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-yam-bean-2',
    name: 'Jicama - Yam Bean 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'legume',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yam Bean 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Yam Bean 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-pachyrhizus-2',
    name: 'Kohlrabi - Pachyrhizus 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pachyrhizus 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Pachyrhizus 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-jicama-de-agua-2',
    name: 'Celeriac - Jicama de Agua 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jicama de Agua 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Jicama de Agua 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-jicama-de-leche-2',
    name: 'Fennel - Jicama de Leche 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jicama de Leche 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Jicama de Leche 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-white-vienna-2',
    name: 'Asparagus - White Vienna 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'White Vienna 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['White Vienna 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-purple-vienna-2',
    name: 'Rhubarb - Purple Vienna 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Purple Vienna 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Purple Vienna 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-grand-duke-2',
    name: 'Artichoke - Grand Duke 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grand Duke 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Grand Duke 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-korridor-2',
    name: 'Cardoon - Korridor 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korridor 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Korridor 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-kossak-2',
    name: 'Okra - Kossak 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kossak 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Kossak 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-brilliant-2',
    name: 'Chayote - Brilliant 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brilliant 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Brilliant 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-monarch-2',
    name: 'Jicama - Monarch 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monarch 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Monarch 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-prague-2',
    name: 'Kohlrabi - Prague 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prague 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Prague 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-tellus-2',
    name: 'Celeriac - Tellus 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tellus 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Tellus 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-alabaster-2',
    name: 'Fennel - Alabaster 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alabaster 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Alabaster 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-florence-2',
    name: 'Asparagus - Florence 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Florence 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Florence 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-perfection-2',
    name: 'Rhubarb - Perfection 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Perfection 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Perfection 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-zefa-fino-2',
    name: 'Artichoke - Zefa Fino 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zefa Fino 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Zefa Fino 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-orion-2',
    name: 'Cardoon - Orion 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Orion 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Orion 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-preludio-2',
    name: 'Okra - Preludio 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Preludio 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Preludio 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-bronze-2',
    name: 'Chayote - Bronze 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bronze 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bronze 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-smokey-2',
    name: 'Jicama - Smokey 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smokey 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Smokey 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-sweet-2',
    name: 'Kohlrabi - Sweet 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Sweet 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-bitter-2',
    name: 'Celeriac - Bitter 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Bitter 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-wild-2',
    name: 'Fennel - Wild 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wild 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Wild 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-early-2',
    name: 'Asparagus - Early 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Early 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Early 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-mid-2',
    name: 'Rhubarb - Mid 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Mid 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Mid 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-late-2',
    name: 'Artichoke - Late 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Late 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Late 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-main-season-2',
    name: 'Cardoon - Main Season 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Main Season 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Main Season 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-all-season-2',
    name: 'Okra - All Season 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'All Season 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['All Season 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-spring-2',
    name: 'Chayote - Spring 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spring 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spring 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-summer-2',
    name: 'Jicama - Summer 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Summer 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Summer 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-fall-2',
    name: 'Kohlrabi - Fall 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fall 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Fall 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-winter-2',
    name: 'Celeriac - Winter 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winter 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Winter 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-perennial-2',
    name: 'Fennel - Perennial 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Perennial 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Perennial 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-annual-2',
    name: 'Asparagus - Annual 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Annual 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Annual 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-biennial-2',
    name: 'Rhubarb - Biennial 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Biennial 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Biennial 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-dwarf-2',
    name: 'Artichoke - Dwarf 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Dwarf 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-giant-2',
    name: 'Cardoon - Giant 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Giant 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-standard-2',
    name: 'Okra - Standard 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Standard 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-green-2',
    name: 'Chayote - Green 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-red-2',
    name: 'Jicama - Red 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Red 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-purple-2',
    name: 'Kohlrabi - Purple 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Purple 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-white-2',
    name: 'Celeriac - White 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['White 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-yellow-2',
    name: 'Fennel - Yellow 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Yellow 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-heirloom-2',
    name: 'Asparagus - Heirloom 2',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom 2 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Heirloom 2'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-heritage-2',
    name: 'Rhubarb - Heritage 2',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Heritage 2 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Heritage 2'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-organic-2',
    name: 'Artichoke - Organic 2',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 2 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Organic 2'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-hybrid-2',
    name: 'Cardoon - Hybrid 2',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 2 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Hybrid 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-f1-2',
    name: 'Okra - F1 2',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'F1 2 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['F1 2'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-disease-resistant-2',
    name: 'Chayote - Disease Resistant 2',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Disease Resistant 2 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Disease Resistant 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-heat-tolerant-2',
    name: 'Jicama - Heat Tolerant 2',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heat Tolerant 2 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Heat Tolerant 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-cold-hardy-2',
    name: 'Kohlrabi - Cold Hardy 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cold Hardy 2 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Cold Hardy 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-drought-tolerant-2',
    name: 'Celeriac - Drought Tolerant 2',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Drought Tolerant 2 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Drought Tolerant 2'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-high-yield-2',
    name: 'Fennel - High Yield 2',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'High Yield 2 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['High Yield 2'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-mary-washington-3',
    name: 'Asparagus - Mary Washington 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Mary Washington 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Mary Washington 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-jersey-giant-3',
    name: 'Rhubarb - Jersey Giant 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Jersey Giant 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Jersey Giant 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-jersey-knight-3',
    name: 'Artichoke - Jersey Knight 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jersey Knight 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Jersey Knight 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-purple-passion-3',
    name: 'Cardoon - Purple Passion 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Passion 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Purple Passion 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-apollo-3',
    name: 'Okra - Apollo 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apollo 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Apollo 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-uc-157-3',
    name: 'Chayote - UC 157 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'UC 157 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['UC 157 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-atlas-3',
    name: 'Jicama - Atlas 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Atlas 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Atlas 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-grande-3',
    name: 'Kohlrabi - Grande 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grande 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Grande 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-precoce-3',
    name: 'Celeriac - Precoce 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Precoce 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Precoce 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-argenteuil-3',
    name: 'Fennel - Argenteuil 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Argenteuil 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Argenteuil 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-victoria-3',
    name: 'Asparagus - Victoria 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Victoria 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Victoria 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-crimson-red-3',
    name: 'Rhubarb - Crimson Red 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Crimson Red 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Crimson Red 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-canada-red-3',
    name: 'Artichoke - Canada Red 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Canada Red 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Canada Red 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-valentine-3',
    name: 'Cardoon - Valentine 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Valentine 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Valentine 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-macdonald-3',
    name: 'Okra - MacDonald 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'MacDonald 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['MacDonald 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-green-3',
    name: 'Chayote - Green 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-red-3',
    name: 'Jicama - Red 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Red 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-pink-3',
    name: 'Kohlrabi - Pink 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pink 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Pink 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-cherry-3',
    name: 'Celeriac - Cherry 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cherry 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Cherry 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-strawberry-3',
    name: 'Fennel - Strawberry 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Strawberry 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Strawberry 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-green-globe-3',
    name: 'Asparagus - Green Globe 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Green Globe 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Green Globe 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-imperial-star-3',
    name: 'Rhubarb - Imperial Star 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Imperial Star 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Imperial Star 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-violetto-3',
    name: 'Artichoke - Violetto 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Violetto 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Violetto 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-purple-3',
    name: 'Cardoon - Purple 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Purple 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-romanesco-3',
    name: 'Okra - Romanesco 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Romanesco 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Romanesco 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-cardoon-3',
    name: 'Chayote - Cardoon 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cardoon 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cardoon 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-spanish-3',
    name: 'Jicama - Spanish 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Spanish 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-portuguese-3',
    name: 'Kohlrabi - Portuguese 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Portuguese 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Portuguese 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-gobbo-3',
    name: 'Celeriac - Gobbo 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gobbo 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Gobbo 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-giant-3',
    name: 'Fennel - Giant 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Giant 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-clemson-spineless-3',
    name: 'Asparagus - Clemson Spineless 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Clemson Spineless 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Clemson Spineless 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-emerald-3',
    name: 'Rhubarb - Emerald 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Emerald 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Emerald 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-annie-oakley-3',
    name: 'Artichoke - Annie Oakley 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Annie Oakley 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Annie Oakley 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-burgundy-3',
    name: 'Cardoon - Burgundy 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Burgundy 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Burgundy 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-red-3',
    name: 'Okra - Red 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Red 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-jambalaya-3',
    name: 'Chayote - Jambalaya 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jambalaya 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jambalaya 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-cajun-delight-3',
    name: 'Jicama - Cajun Delight 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cajun Delight 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Cajun Delight 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-louisiana-green-3',
    name: 'Kohlrabi - Louisiana Green 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Louisiana Green 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Louisiana Green 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-silver-queen-3',
    name: 'Celeriac - Silver Queen 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Silver Queen 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Silver Queen 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-star-of-david-3',
    name: 'Fennel - Star of David 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Star of David 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Star of David 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-christophine-3',
    name: 'Asparagus - Christophine 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Christophine 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Christophine 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-mirliton-3',
    name: 'Rhubarb - Mirliton 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Mirliton 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Mirliton 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-choko-3',
    name: 'Artichoke - Choko 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Choko 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Choko 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-vegetable-pear-3',
    name: 'Cardoon - Vegetable Pear 3',
    scientificName: 'Cynara cardunculus',
    category: 'legume',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vegetable Pear 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Vegetable Pear 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-one-seeded-cucumber-3',
    name: 'Okra - One-Seeded Cucumber 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'One-Seeded Cucumber 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['One-Seeded Cucumber 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-mexican-turnip-3',
    name: 'Chayote - Mexican Turnip 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mexican Turnip 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mexican Turnip 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-yam-bean-3',
    name: 'Jicama - Yam Bean 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'legume',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yam Bean 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Yam Bean 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-pachyrhizus-3',
    name: 'Kohlrabi - Pachyrhizus 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pachyrhizus 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Pachyrhizus 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-jicama-de-agua-3',
    name: 'Celeriac - Jicama de Agua 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jicama de Agua 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Jicama de Agua 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-jicama-de-leche-3',
    name: 'Fennel - Jicama de Leche 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jicama de Leche 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Jicama de Leche 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-white-vienna-3',
    name: 'Asparagus - White Vienna 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'White Vienna 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['White Vienna 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-purple-vienna-3',
    name: 'Rhubarb - Purple Vienna 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Purple Vienna 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Purple Vienna 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-grand-duke-3',
    name: 'Artichoke - Grand Duke 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grand Duke 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Grand Duke 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-korridor-3',
    name: 'Cardoon - Korridor 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korridor 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Korridor 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-kossak-3',
    name: 'Okra - Kossak 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kossak 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Kossak 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-brilliant-3',
    name: 'Chayote - Brilliant 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brilliant 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Brilliant 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-monarch-3',
    name: 'Jicama - Monarch 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monarch 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Monarch 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-prague-3',
    name: 'Kohlrabi - Prague 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prague 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Prague 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-tellus-3',
    name: 'Celeriac - Tellus 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tellus 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Tellus 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-alabaster-3',
    name: 'Fennel - Alabaster 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alabaster 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Alabaster 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-florence-3',
    name: 'Asparagus - Florence 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Florence 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Florence 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-perfection-3',
    name: 'Rhubarb - Perfection 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Perfection 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Perfection 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-zefa-fino-3',
    name: 'Artichoke - Zefa Fino 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zefa Fino 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Zefa Fino 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-orion-3',
    name: 'Cardoon - Orion 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Orion 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Orion 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-preludio-3',
    name: 'Okra - Preludio 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Preludio 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Preludio 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-bronze-3',
    name: 'Chayote - Bronze 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bronze 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bronze 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-smokey-3',
    name: 'Jicama - Smokey 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smokey 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Smokey 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-sweet-3',
    name: 'Kohlrabi - Sweet 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Sweet 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-bitter-3',
    name: 'Celeriac - Bitter 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Bitter 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-wild-3',
    name: 'Fennel - Wild 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wild 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Wild 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-early-3',
    name: 'Asparagus - Early 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Early 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Early 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-mid-3',
    name: 'Rhubarb - Mid 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Mid 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Mid 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-late-3',
    name: 'Artichoke - Late 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Late 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Late 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-main-season-3',
    name: 'Cardoon - Main Season 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Main Season 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Main Season 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-all-season-3',
    name: 'Okra - All Season 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'All Season 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['All Season 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-spring-3',
    name: 'Chayote - Spring 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spring 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spring 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-summer-3',
    name: 'Jicama - Summer 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Summer 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Summer 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-fall-3',
    name: 'Kohlrabi - Fall 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fall 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Fall 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-winter-3',
    name: 'Celeriac - Winter 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winter 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Winter 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-perennial-3',
    name: 'Fennel - Perennial 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Perennial 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Perennial 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-annual-3',
    name: 'Asparagus - Annual 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Annual 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Annual 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-biennial-3',
    name: 'Rhubarb - Biennial 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Biennial 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Biennial 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-dwarf-3',
    name: 'Artichoke - Dwarf 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Dwarf 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-giant-3',
    name: 'Cardoon - Giant 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Giant 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-standard-3',
    name: 'Okra - Standard 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Standard 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-green-3',
    name: 'Chayote - Green 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-red-3',
    name: 'Jicama - Red 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Red 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-purple-3',
    name: 'Kohlrabi - Purple 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Purple 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-white-3',
    name: 'Celeriac - White 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['White 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-yellow-3',
    name: 'Fennel - Yellow 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Yellow 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-heirloom-3',
    name: 'Asparagus - Heirloom 3',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom 3 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Heirloom 3'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-heritage-3',
    name: 'Rhubarb - Heritage 3',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Heritage 3 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Heritage 3'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-organic-3',
    name: 'Artichoke - Organic 3',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 3 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Organic 3'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-hybrid-3',
    name: 'Cardoon - Hybrid 3',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 3 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Hybrid 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-f1-3',
    name: 'Okra - F1 3',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'F1 3 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['F1 3'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-disease-resistant-3',
    name: 'Chayote - Disease Resistant 3',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Disease Resistant 3 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Disease Resistant 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-heat-tolerant-3',
    name: 'Jicama - Heat Tolerant 3',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heat Tolerant 3 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Heat Tolerant 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-cold-hardy-3',
    name: 'Kohlrabi - Cold Hardy 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cold Hardy 3 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Cold Hardy 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-drought-tolerant-3',
    name: 'Celeriac - Drought Tolerant 3',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Drought Tolerant 3 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Drought Tolerant 3'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-high-yield-3',
    name: 'Fennel - High Yield 3',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'High Yield 3 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['High Yield 3'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-mary-washington-4',
    name: 'Asparagus - Mary Washington 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Mary Washington 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Mary Washington 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-jersey-giant-4',
    name: 'Rhubarb - Jersey Giant 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Jersey Giant 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Jersey Giant 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-jersey-knight-4',
    name: 'Artichoke - Jersey Knight 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jersey Knight 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Jersey Knight 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-purple-passion-4',
    name: 'Cardoon - Purple Passion 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple Passion 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Purple Passion 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-apollo-4',
    name: 'Okra - Apollo 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Apollo 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Apollo 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-uc-157-4',
    name: 'Chayote - UC 157 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'UC 157 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['UC 157 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-atlas-4',
    name: 'Jicama - Atlas 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Atlas 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Atlas 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-grande-4',
    name: 'Kohlrabi - Grande 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grande 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Grande 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-precoce-4',
    name: 'Celeriac - Precoce 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Precoce 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Precoce 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-argenteuil-4',
    name: 'Fennel - Argenteuil 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Argenteuil 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Argenteuil 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-victoria-4',
    name: 'Asparagus - Victoria 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Victoria 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Victoria 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-crimson-red-4',
    name: 'Rhubarb - Crimson Red 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Crimson Red 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Crimson Red 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-canada-red-4',
    name: 'Artichoke - Canada Red 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Canada Red 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Canada Red 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-valentine-4',
    name: 'Cardoon - Valentine 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Valentine 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Valentine 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-macdonald-4',
    name: 'Okra - MacDonald 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'MacDonald 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['MacDonald 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-green-4',
    name: 'Chayote - Green 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-red-4',
    name: 'Jicama - Red 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Red 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-pink-4',
    name: 'Kohlrabi - Pink 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pink 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Pink 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-cherry-4',
    name: 'Celeriac - Cherry 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cherry 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Cherry 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-strawberry-4',
    name: 'Fennel - Strawberry 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Strawberry 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Strawberry 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-green-globe-4',
    name: 'Asparagus - Green Globe 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Green Globe 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Green Globe 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-imperial-star-4',
    name: 'Rhubarb - Imperial Star 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Imperial Star 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Imperial Star 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-violetto-4',
    name: 'Artichoke - Violetto 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Violetto 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Violetto 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-purple-4',
    name: 'Cardoon - Purple 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Purple 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-romanesco-4',
    name: 'Okra - Romanesco 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Romanesco 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Romanesco 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-cardoon-4',
    name: 'Chayote - Cardoon 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cardoon 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Cardoon 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-spanish-4',
    name: 'Jicama - Spanish 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spanish 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Spanish 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-portuguese-4',
    name: 'Kohlrabi - Portuguese 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Portuguese 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Portuguese 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-gobbo-4',
    name: 'Celeriac - Gobbo 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Gobbo 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Gobbo 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-giant-4',
    name: 'Fennel - Giant 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Giant 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-clemson-spineless-4',
    name: 'Asparagus - Clemson Spineless 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Clemson Spineless 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Clemson Spineless 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-emerald-4',
    name: 'Rhubarb - Emerald 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Emerald 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Emerald 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-annie-oakley-4',
    name: 'Artichoke - Annie Oakley 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Annie Oakley 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Annie Oakley 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-burgundy-4',
    name: 'Cardoon - Burgundy 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Burgundy 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Burgundy 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-red-4',
    name: 'Okra - Red 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Red 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-jambalaya-4',
    name: 'Chayote - Jambalaya 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jambalaya 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Jambalaya 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-cajun-delight-4',
    name: 'Jicama - Cajun Delight 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cajun Delight 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Cajun Delight 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-louisiana-green-4',
    name: 'Kohlrabi - Louisiana Green 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Louisiana Green 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Louisiana Green 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-silver-queen-4',
    name: 'Celeriac - Silver Queen 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Silver Queen 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Silver Queen 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-star-of-david-4',
    name: 'Fennel - Star of David 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Star of David 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Star of David 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-christophine-4',
    name: 'Asparagus - Christophine 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Christophine 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Christophine 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-mirliton-4',
    name: 'Rhubarb - Mirliton 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Mirliton 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Mirliton 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-choko-4',
    name: 'Artichoke - Choko 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Choko 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Choko 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-vegetable-pear-4',
    name: 'Cardoon - Vegetable Pear 4',
    scientificName: 'Cynara cardunculus',
    category: 'legume',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Vegetable Pear 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Vegetable Pear 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-one-seeded-cucumber-4',
    name: 'Okra - One-Seeded Cucumber 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'One-Seeded Cucumber 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['One-Seeded Cucumber 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-mexican-turnip-4',
    name: 'Chayote - Mexican Turnip 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Mexican Turnip 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Mexican Turnip 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-yam-bean-4',
    name: 'Jicama - Yam Bean 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'legume',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yam Bean 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Yam Bean 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-pachyrhizus-4',
    name: 'Kohlrabi - Pachyrhizus 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Pachyrhizus 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Pachyrhizus 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-jicama-de-agua-4',
    name: 'Celeriac - Jicama de Agua 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jicama de Agua 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Jicama de Agua 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-jicama-de-leche-4',
    name: 'Fennel - Jicama de Leche 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Jicama de Leche 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Jicama de Leche 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-white-vienna-4',
    name: 'Asparagus - White Vienna 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'White Vienna 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['White Vienna 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-purple-vienna-4',
    name: 'Rhubarb - Purple Vienna 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Purple Vienna 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Purple Vienna 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-grand-duke-4',
    name: 'Artichoke - Grand Duke 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Grand Duke 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Grand Duke 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-korridor-4',
    name: 'Cardoon - Korridor 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Korridor 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Korridor 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-kossak-4',
    name: 'Okra - Kossak 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Kossak 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Kossak 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-brilliant-4',
    name: 'Chayote - Brilliant 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Brilliant 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Brilliant 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-monarch-4',
    name: 'Jicama - Monarch 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Monarch 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Monarch 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-prague-4',
    name: 'Kohlrabi - Prague 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Prague 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Prague 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-tellus-4',
    name: 'Celeriac - Tellus 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Tellus 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Tellus 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-alabaster-4',
    name: 'Fennel - Alabaster 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Alabaster 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Alabaster 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-florence-4',
    name: 'Asparagus - Florence 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Florence 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Florence 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-perfection-4',
    name: 'Rhubarb - Perfection 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Perfection 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Perfection 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-zefa-fino-4',
    name: 'Artichoke - Zefa Fino 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Zefa Fino 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Zefa Fino 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-orion-4',
    name: 'Cardoon - Orion 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Orion 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Orion 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-preludio-4',
    name: 'Okra - Preludio 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Preludio 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Preludio 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-bronze-4',
    name: 'Chayote - Bronze 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bronze 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Bronze 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-smokey-4',
    name: 'Jicama - Smokey 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Smokey 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Smokey 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-sweet-4',
    name: 'Kohlrabi - Sweet 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Sweet 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Sweet 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-bitter-4',
    name: 'Celeriac - Bitter 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Bitter 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Bitter 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-wild-4',
    name: 'Fennel - Wild 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Wild 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Wild 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-early-4',
    name: 'Asparagus - Early 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Early 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Early 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-mid-4',
    name: 'Rhubarb - Mid 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Mid 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Mid 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-late-4',
    name: 'Artichoke - Late 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Late 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Late 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-main-season-4',
    name: 'Cardoon - Main Season 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Main Season 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Main Season 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-all-season-4',
    name: 'Okra - All Season 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'All Season 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['All Season 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-spring-4',
    name: 'Chayote - Spring 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Spring 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Spring 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-summer-4',
    name: 'Jicama - Summer 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Summer 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Summer 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-fall-4',
    name: 'Kohlrabi - Fall 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Fall 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Fall 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-winter-4',
    name: 'Celeriac - Winter 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Winter 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Winter 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-perennial-4',
    name: 'Fennel - Perennial 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Perennial 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Perennial 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-annual-4',
    name: 'Asparagus - Annual 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Annual 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Annual 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-biennial-4',
    name: 'Rhubarb - Biennial 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Biennial 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Biennial 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-dwarf-4',
    name: 'Artichoke - Dwarf 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Dwarf 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Dwarf 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-giant-4',
    name: 'Cardoon - Giant 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Giant 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Giant 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-standard-4',
    name: 'Okra - Standard 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Standard 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['Standard 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-green-4',
    name: 'Chayote - Green 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Green 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Green 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-red-4',
    name: 'Jicama - Red 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Red 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Red 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-purple-4',
    name: 'Kohlrabi - Purple 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Purple 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Purple 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-white-4',
    name: 'Celeriac - White 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'White 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['White 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-yellow-4',
    name: 'Fennel - Yellow 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Yellow 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Yellow 4'],
    uses: ['cooking', 'salads', 'fish']
  },
  {
    id: 'asparagus-heirloom-4',
    name: 'Asparagus - Heirloom 4',
    scientificName: 'Asparagus officinalis',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 21,
    daysToHarvest: 1095,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['tomato', 'parsley'],
    enemies: ['onion', 'garlic'],
    description: 'Heirloom 4 asparagus. Perennial spring delicacy, harvest year 3.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '2-3 feet',
    family: 'Asparagaceae',
    varieties: ['Heirloom 4'],
    uses: ['grilling', 'roasting', 'fresh']
  },
  {
    id: 'rhubarb-heritage-4',
    name: 'Rhubarb - Heritage 4',
    scientificName: 'Rheum rhabarbarum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 730,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['garlic', 'onion'],
    enemies: [],
    description: 'Heritage 4 rhubarb. Tart stalks for pie, poisonous leaves.',
    hardinessZones: '3-8',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Polygonaceae',
    varieties: ['Heritage 4'],
    uses: ['pie', 'compote', 'jam']
  },
  {
    id: 'artichoke-organic-4',
    name: 'Artichoke - Organic 4',
    scientificName: 'Cynara cardunculus var. scolymus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Organic 4 artichoke. Thistle family, harvest before bloom.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Organic 4'],
    uses: ['steaming', 'dipping', 'hearts']
  },
  {
    id: 'cardoon-hybrid-4',
    name: 'Cardoon - Hybrid 4',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 10,
    daysToHarvest: 150,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Hybrid 4 cardoon. Artichoke cousin, eat stems not flower.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Hybrid 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'okra-f1-4',
    name: 'Okra - F1 4',
    scientificName: 'Abelmoschus esculentus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'F1 4 okra. Gumbo essential, heat loving.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-5 feet',
    spread: '12-24 inches',
    family: 'Malvaceae',
    varieties: ['F1 4'],
    uses: ['gumbo', 'frying', 'pickling']
  },
  {
    id: 'chayote-disease-resistant-4',
    name: 'Chayote - Disease Resistant 4',
    scientificName: 'Sechium edule',
    category: 'vegetable',
    spacing: 72,
    rowSpacing: 96,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Disease Resistant 4 chayote. Wrinkled green fruit, mild flavor.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: 'vines to 30 feet',
    family: 'Cucurbitaceae',
    varieties: ['Disease Resistant 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'jicama-heat-tolerant-4',
    name: 'Jicama - Heat Tolerant 4',
    scientificName: 'Pachyrhizus erosus',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 180,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Heat Tolerant 4 jicama. Crisp white tuber, Mexican favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Fabaceae',
    varieties: ['Heat Tolerant 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'kohlrabi-cold-hardy-4',
    name: 'Kohlrabi - Cold Hardy 4',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Cold Hardy 4 kohlrabi. Alien-looking bulb stem.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Cold Hardy 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'celeriac-drought-tolerant-4',
    name: 'Celeriac - Drought Tolerant 4',
    scientificName: 'Apium graveolens var. rapaceum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'Drought Tolerant 4 celeriac. Knobby celery-flavored root.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['Drought Tolerant 4'],
    uses: ['cooking', 'salads', 'stew']
  },
  {
    id: 'fennel-high-yield-4',
    name: 'Fennel - High Yield 4',
    scientificName: 'Foeniculum vulgare',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: [],
    enemies: [],
    description: 'High Yield 4 fennel. Anise-flavored bulb and feathery leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-24 inches',
    spread: '12-24 inches',
    family: 'Apiaceae',
    varieties: ['High Yield 4'],
    uses: ['cooking', 'salads', 'fish']
  }
]
